// English interface texts, keyed by the French text as rendered (whitespace
// collapsed; {0}, {1}… are the values of a template). Regenerate the list
// of missing texts with `node scripts/i18n-strings.js`.
const en = {
  "% (ordres en devise)": "% (foreign-currency orders)",
  "% de l’ordre": "% of the order",
  "% par an, ces frais coûtent": "% a year, these fees cost",
  "%/an": "%/yr",
  "(Paris)": "(Paris)",
  "(actuel)": "(current)",
  "(cible": "(target",
  "(désactivé)": "(disabled)",
  "(erreur « {0} »)": "(error “{0}”)",
  "(facultatif)": "(optional)",
  "(le jury ne s’est pas prononcé)": "(the jury did not decide)",
  "(liquidités comprises)": "(cash included)",
  "(sans compter vos futurs versements).": "(not counting your future deposits).",
  "(variation médiane : {0} %)": "(median change: {0} %)",
  "(versement et liquidités au-delà de la réserve).": "(deposit and cash above the reserve).",
  "(versements compris)": "(deposits included)",
  "({0} autre{1} ordre{2} traité{3})": "({0} other order{2} processed)",
  "(échec du panel)": "(panel failed)",
  "+/- value": "Gain / loss",
  "+/- value latente": "Unrealised gain / loss",
  "+/- value totale": "Total gain / loss",
  ", aurait aujourd’hui": ", would be worth today",
  ", avec votre versement mensuel": ", with your monthly deposit",
  ", cours aujourd’hui": ", price today",
  ", dans {0} jour{1}": ", in {0} day{1}",
  ", dont": ", of which",
  ", le CAC 40": ", the CAC 40",
  ", le fantôme fait": ", the ghost makes",
  ", liquidités inchangées": ", cash unchanged",
  ", l’ETF monde": ", the world ETF",
  ", selon votre barème.": ", at your fee schedule.",
  ", sur {0} séances depuis {1}.": ", over {0} sessions since {1}.",
  ", un lien de réinitialisation valable une heure vient d’y être envoyé.": ", a reset link valid for one hour has just been sent to it.",
  ", votre compte": ", your account",
  ", vous avez choisi d’attendre.": ", you chose to wait.",
  ", {0} achat{1} programmé{2} après les ventes": ", {0} buy{1} scheduled after the sells",
  ". Derniers cours connus, frais non inclus.": ". Last known prices, fees not included.",
  ". La présidente rédige son verdict…": ". The presiding judge is writing her verdict…",
  ". Les poids peuvent aussi suivre l’arène ou la calibration des experts (Trading › Arène des experts).": ". Weights can also follow the experts' arena or calibration (Trading › Experts' arena).",
  ". Suivez l’exécution dans le journal.": ". Follow the execution in the journal.",
  "/an": "/yr",
  "0 = sans limite": "0 = no limit",
  "1 sur 10 dépasse": "1 in 10 exceeds",
  "1 univers sur 10 finit sous": "1 universe in 10 ends below",
  "20 séances": "20 sessions",
  "5 ans atteints": "5 years reached",
  "5 séances": "5 sessions",
  "60 séances": "60 sessions",
  ": aucun ordre ne part, quelle que soit son origine.": ": no order leaves, whatever its origin.",
  ": consultez leur DIC.": ": see their KID.",
  ": c’est ce qu’il reste avant le plafond de": ": that is what is left before the ceiling of",
  ": il pèse comme": ": it weighs as much as",
  ": la valeur de votre PEA (": ": the value of your PEA (",
  ": ordres en argent réel": ": real-money orders",
  ": retenue à la source non comptée.": ": withholding tax not counted.",
  ": retraits partiels possibles sans clôture, gains soumis aux seuls prélèvements sociaux (": ": partial withdrawals possible without closing, gains subject to social contributions only (",
  ": vous": ": you",
  ": écart de": ": gap of",
  "; historique indisponible pour {0} (sensibilité par défaut).": "; history unavailable for {0} (default sensitivity).",
  "; un an plus tard :": "; a year later:",
  "A rejoint une position sur {0}": "Joined a position on {0}",
  "Abonnez votre agenda : détachements de dividendes et publications de résultats de vos lignes, réunions de la BCE, cinq ans du PEA et jour de versement. Mis à jour toutes les six heures environ, sans aucun montant.": "Subscribe your calendar: ex-dividend dates and earnings releases of your holdings, ECB meetings, the PEA's fifth anniversary and the deposit day. Updated about every six hours, never with any amount.",
  "Accord européen sur la dette grecque : forte hausse.": "European agreement on the Greek debt: a strong rise.",
  "Accès au micro refusé : autorisez-le dans le navigateur pour parler à Gladys.": "Microphone access denied: allow it in the browser to talk to Gladys.",
  "Accès à votre compte pour importer le portefeuille.": "Access to your account to import the portfolio.",
  "Achat": "Buy",
  "Achat au marché": "Market buy",
  "Achat {0} au marché": "Buy {0} at market",
  "Achat {0} au marché {1}": "Buy {0} at market {1}",
  "Achat {0} stop limite": "Buy {0} stop limit",
  "Achat {0} stop limite {1}": "Buy {0} stop limit {1}",
  "Achat {0} stop suiveur": "Buy {0} trailing stop",
  "Achat {0} stop suiveur {1}": "Buy {0} trailing stop {1}",
  "Achat {0} à cours limité": "Buy {0} limit",
  "Achat {0} à cours limité {1}": "Buy {0} limit {1}",
  "Achat {0} à seuil de déclenchement": "Buy {0} stop",
  "Achat {0} à seuil de déclenchement {1}": "Buy {0} stop {1}",
  "Achat étalé": "Staggered buying",
  "Achats": "Buys",
  "Achats :": "Buys:",
  "Achats réduits : liquidités et ventes ne suffisent pas à tout acheter sans entamer la réserve.": "Buys reduced: cash and sells are not enough to buy everything without touching the reserve.",
  "Achats étalés": "Staggered buying",
  "Acheter": "Buy",
  "Acheter maintenant": "Buy now",
  "Acquittée": "Acknowledged",
  "Actif ({0})": "Active ({0})",
  "Action": "Action",
  "Action impossible.": "Action failed.",
  "Action inconnue.": "Unknown action.",
  "Action principale": "Primary action",
  "Actions": "Shares",
  "Actions et ETF à surveiller": "Shares and ETFs to watch",
  "Activer la voix": "Enable the voice",
  "Activer le réel": "Enable real money",
  "Activer sur cet appareil": "Enable on this device",
  "Activez les notifications : le navigateur vous demandera votre accord.": "Enable notifications: the browser will ask for your consent.",
  "Activées": "Enabled",
  "Actualiser": "Refresh",
  "Actualiser la watchlist": "Refresh the watchlist",
  "Actualiser le portefeuille": "Refresh the portfolio",
  "Actualiser les rapports": "Refresh the reports",
  "Actualiser les rapports d'experts": "Refresh the expert reports",
  "Actualiser les rumeurs de {0}": "Refresh the rumours about {0}",
  "Actualités": "News",
  "Actualités récentes": "Recent news",
  "Actuel": "Current",
  "Adolescent": "Teenager",
  "Adresse copiée": "Address copied",
  "Adresse de retour": "Redirect address",
  "Adresse email": "Email address",
  "Adulte": "Adult",
  "Afficher": "Show",
  "Afficher Gladys": "Show Gladys",
  "Afficher la clé": "Show the key",
  "Afficher le rapport en plein écran": "Show the report full screen",
  "Afficher le texte": "Show the text",
  "Afficher les montants": "Show amounts",
  "Afrique du Sud": "South Africa",
  "Ajouter": "Add",
  "Ajouter l’expert": "Add the expert",
  "Ajouter un expert": "Add an expert",
  "Ajouter {0} à la watchlist": "Add {0} to the watchlist",
  "Ajouter à Google Agenda": "Add to Google Calendar",
  "Ajoutez des actions ou des ETF européens pour suivre leurs rumeurs ; la liste est partagée avec le portefeuille.": "Add European shares or ETFs to follow their rumours; the list is shared with the portfolio.",
  "Ajustez le cours ou la quantité si besoin : rien n’est envoyé avant votre confirmation.": "Adjust the price or the quantity if needed: nothing is sent before your confirmation.",
  "Alerte : {0}.": "Alert: {0}.",
  "Alertes de marché": "Market alerts",
  "Aligné": "Aligned",
  "Allemagne": "Germany",
  "Allocation cible": "Target allocation",
  "Allocation cible enregistrée": "Target allocation saved",
  "Allocation commune": "Common allocation",
  "Alléger": "Trim",
  "Alléger la ligne": "Trim the line",
  "Alpha maximal": "Maximum alpha",
  "An": "Year",
  "Analyse IA": "AI analysis",
  "Analyse complète": "Full analysis",
  "Analyse des actualités de vos valeurs…": "Analysing the news of your holdings…",
  "Analyse des positions": "Position analysis",
  "Analyse détaillée de la performance": "Detailed performance analysis",
  "Analyse en cours…": "Analysis in progress…",
  "Analyse individuelle": "Single analysis",
  "Analyse le risque de mon portefeuille": "Analyse the risk of my portfolio",
  "Analyse matinale PEA": "PEA morning analysis",
  "Analyse matinale du portefeuille": "Morning portfolio analysis",
  "Analyse prête": "Analysis ready",
  "Analyser les {0} positions": "Analyse the {0} positions",
  "Analyses": "Analyses",
  "Analyses fournies à titre informatif, sans valeur de conseil en investissement.": "Analyses provided for information only, not investment advice.",
  "Analyses individuelles": "Individual analyses",
  "Analyses individuelles de chaque expert et débats entre experts, avant la consolidation en rapport global.": "Each expert's individual analysis and the debates between experts, before the consolidation into a global report.",
  "Angle d’analyse": "Analysis angle",
  "Angle à privilégier, par ex. value et dividendes, macro et taux, analyse technique…": "Angle to favour, e.g. value and dividends, macro and rates, technical analysis…",
  "Annonce du vaccin Pfizer-BioNTech : le CAC 40 gagne près de 8 %.": "Pfizer-BioNTech vaccine announced: the CAC 40 gains nearly 8 %.",
  "Annulation impossible.": "Cancellation failed.",
  "Annuler": "Cancel",
  "Annuler aussi les ordres en attente, programmés et proposés.": "Also cancel the pending, scheduled and proposed orders.",
  "Annuler cet ordre ?": "Cancel this order?",
  "Annuler le rappel": "Cancel the reminder",
  "Annuler les ordres": "Cancel the orders",
  "Annuler l’ordre": "Cancel the order",
  "Annulé": "Cancelled",
  "Année": "Year",
  "Antériorité": "Seniority",
  "Antériorité fiscale": "Tax seniority",
  "Aperçu de l’image de l’année {0}": "Preview of the {0} year image",
  "Apparence de Gladys": "Gladys's look",
  "Appel avec Gladys": "Call with Gladys",
  "Appel interrompu": "Call interrupted",
  "Appel vocal avec Gladys": "Voice call with Gladys",
  "Application": "Application",
  "Application SIM connectée": "SIM application connected",
  "Application enregistrée, pas encore connectée": "Application saved, not connected yet",
  "Application oubliée": "Application forgotten",
  "Application réelle connectée": "Real-money application connected",
  "Approche offensive orientée surperformance.": "Aggressive approach aiming at outperformance.",
  "Approuvé": "Approved",
  "Appuyez sur Entrée pour l’envoyer, ou précisez d’abord votre question.": "Press Enter to send it, or refine your question first.",
  "Après 5 ans, le retrait partiel ne supporte que les prélèvements sociaux sur sa part de plus-value.": "After 5 years, a partial withdrawal only bears social contributions on its share of gains.",
  "Après 5 ans, les gains ne supportent plus que les prélèvements sociaux.": "After 5 years, gains only bear social contributions.",
  "Après chaque débat quotidien, le pilote transforme les décisions du panel assez convaincues en ordres, dans votre enveloppe. Chaque ordre passe les garde-fous ; le coupe-circuit arrête tout.": "After each daily debate, the pilot turns the panel's decisions that are convincing enough into orders, within your envelope. Every order goes through the guard rails; the kill switch stops everything.",
  "Après chaque débat quotidien, l’agent écrit le plan d’ordres du jour et le programme. Chaque ordre passe les garde-fous ; le coupe-circuit arrête tout.": "After each daily debate, the agent writes the day's order plan and schedules it. Every order goes through the guard rails; the kill switch stops everything.",
  "Après l’achat, en % de la valeur du compte.": "After the purchase, in % of the account value.",
  "Après publication": "After the release",
  "Après une séance à {0} % ou pire, le CAC 40 était plus haut un an plus tard dans {1} % des cas": "After a session at {0} % or worse, the CAC 40 was higher a year later in {1} % of cases",
  "Arabie saoudite": "Saudi Arabia",
  "Argent réel": "Real money",
  "Armer · {0} titre{1}": "Arm · {0} share{1}",
  "Armée": "Armed",
  "Arrêter": "Stop",
  "Arrêter ce programme ?": "Stop this programme?",
  "Arène": "Arena",
  "Arène des experts": "Experts' arena",
  "Arène indisponible.": "Arena unavailable.",
  "Assistante IA": "AI assistant",
  "Associer un second ordre : le premier exécuté annule l’autre": "Pair a second order: the first one executed cancels the other",
  "Atteint le": "Reached on",
  "Attendre 24 h": "Wait 24 h",
  "Attendre 24 heures": "Wait 24 hours",
  "Au début du débat quotidien et à la fin d’un débat lancé à la demande.": "At the start of the daily debate and at the end of an on-demand debate.",
  "Au marché": "At market",
  "Au moins 8 caractères": "At least 8 characters",
  "Au prochain palier ({0}), il prendrait la branche": "At the next stage ({0}), it would take the branch",
  "Au prorata gains / valeur du plan": "Pro rata gains / plan value",
  "Au seuil, devient un ordre à cours limité.": "At the trigger, becomes a limit order.",
  "Au total, garder ces lignes vous aurait": "In total, keeping these lines would have",
  "Au {0}": "On {0}",
  "Au-delà de dix ans": "Beyond ten years",
  "Au-dessus, la tranche attend le lendemain.": "Above it, the slice waits for the next day.",
  "Aucun achat possible : les liquidités et les ventes ne couvrent pas la réserve visée.": "No buy possible: cash and sells do not cover the target reserve.",
  "Aucun achat proposé.": "No buy proposed.",
  "Aucun appareil n’a reçu la notification : désactivez puis réactivez les notifications sur cet appareil.": "No device received the notification: turn notifications off and on again on this device.",
  "Aucun briefing pour le moment": "No briefing yet",
  "Aucun courtier ne donne les frais réellement payés : reportez sa grille tarifaire, le calcul l’applique à vos ordres des douze derniers mois.": "No broker gives the fees actually paid: enter its price list, the calculation applies it to your orders of the last twelve months.",
  "Aucun dividende": "No dividend",
  "Aucun dividende pour l’instant : la boule de neige démarre avec un premier versement.": "No dividend yet: the snowball starts with a first payment.",
  "Aucun dividende versé en {0}": "No dividend paid in {0}",
  "Aucun dividende à venir": "No upcoming dividend",
  "Aucun débat d'experts pour l'instant. Il apparaîtra ici dès la prochaine génération du rapport quotidien.": "No expert debate yet. It will appear here with the next daily report.",
  "Aucun débat en cours. Dernier débat :": "No debate in progress. Last debate:",
  "Aucun expert ne peut écrire le plan.": "No expert can write the plan.",
  "Aucun expert pour le moment.": "No expert yet.",
  "Aucun intérêt": "No interest",
  "Aucun modèle chargé : utilisez « Actualiser ».": "No model loaded: use “Refresh”.",
  "Aucun mouvement pour l’instant.": "No movement yet.",
  "Aucun ordre clos pour l’instant.": "No closed order yet.",
  "Aucun ordre du jour : le panel s'est arrêté avant cette phase.": "No agenda: the panel stopped before this phase.",
  "Aucun ordre en cours.": "No order in progress.",
  "Aucun ordre exécuté mesuré pour l’instant.": "No measured executed order yet.",
  "Aucun ordre ne correspond à ces filtres.": "No order matches these filters.",
  "Aucun ordre nécessaire": "No order needed",
  "Aucun ordre vérifié.": "No order checked.",
  "Aucun ordre.": "No order.",
  "Aucun procès pour le moment": "No trial yet",
  "Aucun programme pour l’instant.": "No programme yet.",
  "Aucun rapport pour le moment : le premier arrive avec la prochaine analyse matinale.": "No report yet: the first one comes with the next morning analysis.",
  "Aucun rapport pour l’instant.": "No report yet.",
  "Aucun rapport quotidien enregistré. Les rapports apparaîtront ici après leur génération.": "No daily report saved. Reports will appear here once generated.",
  "Aucun résultat pour «": "No result for “",
  "Aucun titre trouvé.": "No security found.",
  "Aucune": "None",
  "Aucune : que faire de cette valeur ?": "None: what to do with this holding?",
  "Aucune action en portefeuille": "No share in the portfolio",
  "Aucune actualité marquante": "No notable news",
  "Aucune actualité marquante pour vos valeurs.": "No notable news for your holdings.",
  "Aucune actualité ne correspond au filtre": "No news matches the filter",
  "Aucune actualité récente pour cette valeur.": "No recent news for this holding.",
  "Aucune actualité significative n'a été trouvée pour vos valeurs.": "No significant news was found for your holdings.",
  "Aucune analyse enregistrée.": "No analysis saved.",
  "Aucune analyse pour le moment.": "No analysis yet.",
  "Aucune cible": "No target",
  "Aucune consolidation : le panel s'est arrêté avant cette phase.": "No consolidation: the panel stopped before this phase.",
  "Aucune conversation pour le moment": "No conversation yet",
  "Aucune corrélation notable (au-dessus de 0,3).": "No notable correlation (above 0.3).",
  "Aucune crise disponible": "No crisis available",
  "Aucune date connue pour vos lignes dans les trois prochains mois.": "No known date for your holdings in the next three months.",
  "Aucune donnée de performance sur cette période.": "No performance data over this period.",
  "Aucune donnée sur cette période.": "No data over this period.",
  "Aucune donnée.": "No data.",
  "Aucune décision notée pour l’instant.": "No decision scored yet.",
  "Aucune décision sur vos lignes ou votre watchlist dans ce débat.": "No decision on your holdings or your watchlist in this debate.",
  "Aucune déclaration sur six mois.": "No declaration over six months.",
  "Aucune lecture pour l’instant": "No reading yet",
  "Aucune ligne sur ce compte.": "No line in this account.",
  "Aucune opération ne correspond à la recherche": "No transaction matches the search",
  "Aucune plus ou moins-value.": "No gain or loss.",
  "Aucune position": "No position",
  "Aucune position clôturée": "No closed position",
  "Aucune position courte publiée (seuil de 0,5 % du capital).": "No published short position (0.5 % of the capital threshold).",
  "Aucune position individuelle notée pour l’instant.": "No individual position scored yet.",
  "Aucune position isolée": "No isolated position",
  "Aucune position ne correspond à vos critères": "No position matches your criteria",
  "Aucune position trouvée.": "No position found.",
  "Aucune position valorisée.": "No valued position.",
  "Aucune rumeur chargée pour le moment.": "No rumour loaded yet.",
  "Aucune table ronde : tous les points étaient actés d'office.": "No round table: every item was settled at once.",
  "Aucune vente à rejouer": "No sale to replay",
  "Aucune étoile pour l’instant": "No star yet",
  "Audience": "Hearing",
  "Audience interrompue": "Hearing interrupted",
  "Australie": "Australia",
  "Autonome (agent IA)": "Autonomous (AI agent)",
  "Autoriser": "Allow",
  "Autre": "Other",
  "Autres": "Others",
  "Autres lignes": "Other lines",
  "Autriche": "Austria",
  "Aux derniers cours connus, sur {0} au total.": "At the last known prices, out of {0} in total.",
  "Avancement du débat": "Debate progress",
  "Avancement vers les 5 ans": "Progress towards 5 years",
  "Avant 5 ans, un retrait entraîne la clôture du plan et l’imposition de tout son gain net, quel que soit le montant demandé (sauf licenciement, invalidité, création d’entreprise…).": "Before 5 years, a withdrawal closes the plan and taxes all of its net gain, whatever the amount (except dismissal, disability, business creation…).",
  "Avant cette date, tout retrait clôture le plan (hors cas prévus par la loi).": "Before this date, any withdrawal closes the plan (except the cases set by law).",
  "Avant de vendre dans l’urgence, prenez une minute : ce que disent votre plan, le panel et l’histoire du marché.": "Before selling in a hurry, take a minute: what your plan, the panel and market history say.",
  "Avant de vendre, prenez une minute pour relire votre plan.": "Before selling, take a minute to read your plan again.",
  "Avant publication": "Before the release",
  "Avec erreur": "With an error",
  "Avec icône": "With an icon",
  "Avec les dividendes réinvestis, l’année où ils couvrent chaque dépense.": "With the dividends reinvested, the year they cover each expense.",
  "Avec l’effet de levier de {0}, votre exposition économique atteint {1} de vos placements.": "With the leverage of {0}, your economic exposure reaches {1} of your investments.",
  "Avec un versement mensuel": "With a monthly deposit",
  "Averses": "Showers",
  "Avis non conclusif": "Inconclusive opinion",
  "Baisse": "Fall",
  "Bande claire : 8 trajectoires sur 10. Bande foncée : la moitié. Trait : la médiane. Pointillés : votre objectif.": "Light band: 8 paths out of 10. Dark band: half of them. Line: the median. Dashes: your goal.",
  "Bande dessinée : {0}": "Comic strip: {0}",
  "Banque privée": "Private bank",
  "Barème enregistré": "Fee schedule saved",
  "Belgique": "Belgium",
  "Bilan": "Review",
  "Bilan du panel": "Panel scorecard",
  "Bilan du trading": "Trading review",
  "Bilan indisponible.": "Review unavailable.",
  "Bilan {0}": "Review {0}",
  "Bloqué": "Blocked",
  "Bloquées": "Blocked",
  "Bon retour": "Welcome back",
  "Bonjour, je suis Gladys": "Hello, I'm Gladys",
  "Boule de neige sur dix ans": "Ten-year snowball",
  "Boutons": "Buttons",
  "Branchez votre application de trading Saxo": "Plug in your Saxo trading application",
  "Brier": "Brier",
  "Brésil": "Brazil",
  "Budget invalide.": "Invalid budget.",
  "Budget par proposition": "Budget per proposal",
  "Budget par tir": "Budget per shot",
  "Budget sous le prix d’un titre": "Budget below the price of one share",
  "Bébé": "Baby",
  "CAC 40 : {0} %.": "CAC 40: {0} %.",
  "CAC 40 : {0} · écart {1} pts": "CAC 40: {0} · gap {1} pts",
  "CAC 40 : {0}.": "CAC 40: {0}.",
  "CAC 40 et Euro Stoxx 50 : indices de prix, hors dividendes. CW8 : ETF capitalisant, dividendes réinvestis.": "CAC 40 and Euro Stoxx 50: price indices, dividends excluded. CW8: accumulating ETF, dividends reinvested.",
  "CAC 40 ▲ EURO STOXX ▼ BRENT ▲ OAT 10 ANS ▲ MSCI WORLD ▲": "CAC 40 ▲ EURO STOXX ▼ BRENT ▲ 10Y OAT ▲ MSCI WORLD ▲",
  "CAC 40, dernière séance": "CAC 40, last session",
  "CFD sur action": "Share CFD",
  "Cache vidé": "Cache cleared",
  "Calcul de l’exposition…": "Computing the exposure…",
  "Calcul du versement nécessaire…": "Computing the deposit needed…",
  "Calculés chaque jour à partir de votre portefeuille, de vos frais, de vos réactions aux baisses et de vos versements.": "Computed every day from your portfolio, your fees, your reactions to falls and your deposits.",
  "Calendrier": "Calendar",
  "Calendrier des versements": "Payment calendar",
  "Calendrier indisponible.": "Calendar unavailable.",
  "Calibration": "Calibration",
  "Calibration de {0} : {1}": "Calibration of {0}: {1}",
  "Calibration des experts": "Experts' calibration",
  "Calibration indisponible.": "Calibration unavailable.",
  "Case à cocher": "Checkbox",
  "Ce champ est obligatoire": "This field is required",
  "Ce lien est privé : quiconque le possède voit vos dates (jamais vos montants). Renouvelez-le s’il a circulé.": "This link is private: anyone who has it sees your dates (never your amounts). Renew it if it has been shared.",
  "Ce lien n'est plus valable : demandez-en un nouveau.": "This link is no longer valid: ask for a new one.",
  "Ce lien n’est plus valable : demandez-en un nouveau.": "This link is no longer valid: ask for a new one.",
  "Ce navigateur ne prend pas en charge les notifications push.": "This browser does not support push notifications.",
  "Ce navigateur n’a aucune voix de synthèse : Gladys répond par écrit. Sur Linux, Firefox installé en snap et Chromium n’accèdent souvent pas aux voix du système ; Chrome, Edge, Safari ou un téléphone en ont.": "This browser has no speech voice: Gladys answers in writing. On Linux, Firefox installed as a snap and Chromium often cannot reach the system voices; Chrome, Edge, Safari or a phone have them.",
  "Ce numéro n’a pas encore sa bande dessinée.": "This issue does not have its comic strip yet.",
  "Ce que disait le panel": "What the panel said",
  "Ce que le pilote a vraiment fait face au fantôme qui suit le panel en théorie, à votre compte et au CAC 40 ; puis la qualité de vos exécutions.": "What the pilot really did against the ghost that follows the panel in theory, your account and the CAC 40; then the quality of your executions.",
  "Ce que vos dividendes paient": "What your dividends pay for",
  "Ce que vous coûtent chaque année le courtage, les ETF et les impôts étrangers sur les dividendes, et ce que cela pèse sur vingt ans.": "What brokerage, ETFs and foreign taxes on dividends cost you each year, and what that weighs over twenty years.",
  "Ce que vous obtiendrez": "What you will get",
  "Ce qui se passe si vous retirez un montant aujourd’hui.": "What happens if you withdraw an amount today.",
  "Ce rapport ne contient pas de synthèse exploitable.": "This report has no usable summary.",
  "Ce retrait clôture votre PEA": "This withdrawal closes your PEA",
  "Ces titres sont analysés individuellement dans une section dédiée du prochain rapport quotidien par email, sans modifier les totaux de votre portefeuille.": "These securities are analysed one by one in a dedicated section of the next daily email report, without changing your portfolio's totals.",
  "Cet appareil": "This device",
  "Cet appareil reçoit les notifications choisies ci-dessous.": "This device receives the notifications chosen below.",
  "Cet expert est désactivé : le premier expert actif fera office de rapporteur.": "This expert is disabled: the first active expert will act as rapporteur.",
  "Cette instance de PEA Wallet n’accepte pas de nouveaux comptes.": "This PEA Wallet instance does not accept new accounts.",
  "Cette proposition n’attend plus de confirmation ({0}).": "This proposal is no longer waiting for confirmation ({0}).",
  "Cette valeur n’est ni en portefeuille ni dans votre watchlist : actualités et rumeurs ne sont pas chargées.": "This security is neither in the portfolio nor in your watchlist: news and rumours are not loaded.",
  "Change": "Currency",
  "Changement impossible.": "Change failed.",
  "Changer de compte": "Change account",
  "Changer de fournisseur impose une nouvelle clé.": "Changing provider requires a new key.",
  "Changer d’instrument": "Change instrument",
  "Chaque dividende des douze derniers mois revient au même mois, au nombre d’actions actuel, net des retenues étrangères.": "Each dividend of the last twelve months comes back in the same month, at the current number of shares, net of foreign withholding.",
  "Chaque décision du panel est confrontée au marché : la valeur a-t-elle fait mieux ou moins bien que le CAC 40 ?": "Each panel decision is checked against the market: did the security do better or worse than the CAC 40?",
  "Chaque expert analyse la journée de façon indépendante ; leurs désaccords passent en table ronde, puis le panel signe un rapport commun.": "Each expert analyses the day independently; their disagreements go to a round table, then the panel signs a joint report.",
  "Chaque expert analyse le même dossier de recherche, sans voir les autres.": "Each expert analyses the same research file without seeing the others.",
  "Chaque expert compte pour une voix.": "Each expert has one vote.",
  "Chaque expert critique l'analyse de chaque autre expert, qui lui répond.": "Each expert critiques every other expert's analysis, who answers.",
  "Chaque expert gère une enveloppe virtuelle qui ne suit que ses propres avis des débats quotidiens (action et poids cible, intérêt pour la watchlist, liquidités), avec votre barème de frais.": "Each expert manages a virtual envelope that only follows its own opinions from the daily debates (action and target weight, watchlist interest, cash), with your fee schedule.",
  "Chaque ordre passe par les garde-fous du PEA. Les ventes partent d’abord ; les achats partent quand elles sont exécutées.": "Every order goes through the PEA's guard rails. Sells leave first; buys leave once they are executed.",
  "Chaque ordre, d’où il vient et pourquoi, la cotation au moment de l’envoi, l’exécution et le glissement en points de base (positif = payé plus cher que le milieu de fourchette).": "Every order, where it comes from and why, the quote when it left, the execution and the slippage in basis points (positive = paid more than the mid).",
  "Chaque point est une trajectoire tirée de l’histoire {0} depuis {1}{2}.": "Each dot is a path drawn from the {0} history since {1}{2}.",
  "Chaque vente des cinq dernières années, valorisée au dernier cours. Dividendes non comptés ; ce que vous avez fait de l’argent non plus.": "Every sale of the last five years, valued at the last price. Dividends not counted; nor what you did with the money.",
  "Chaque voix compte entre ×0,5 et ×1,5 selon les positions justes de l’expert à 20 séances (un expert sans historique compte ×1). L’unanimité et la décision par défaut ne changent pas ; les poids figurent en tête du rapport et dans le": "Each vote counts between ×0.5 and ×1.5 depending on the expert's right calls at 20 sessions (an expert without history counts ×1). Unanimity and the default decision do not change; the weights are shown at the top of the report and in the",
  "Chaque voix pèse selon la calibration des probabilités de l’expert (score de Brier à 20 séances, bilan du panel), entre 0,5 et 1,5.": "Each vote weighs by the calibration of the expert's probabilities (Brier score at 20 sessions, panel scorecard), between 0.5 and 1.5.",
  "Chaque voix pèse selon la justesse passée de l’expert (bilan du panel à 20 séances).": "Each vote weighs by the expert's past accuracy (panel scorecard at 20 sessions).",
  "Chaque voix pèse selon la performance de l’enveloppe de l’expert : 1 ± l’écart à la médiane / 20 points, entre 0,5 et 1,5.": "Each vote weighs by the performance of the expert's envelope: 1 ± the gap to the median / 20 points, between 0.5 and 1.5.",
  "Chargement": "Loading",
  "Chargement de l'historique…": "Loading the history…",
  "Chargement de la performance…": "Loading the performance…",
  "Chargement de la watchlist…": "Loading the watchlist…",
  "Chargement de l’historique…": "Loading the history…",
  "Chargement des conversations…": "Loading the conversations…",
  "Chargement des dividendes…": "Loading the dividends…",
  "Chargement des experts…": "Loading the experts…",
  "Chargement des modèles…": "Loading the models…",
  "Chargement des notifications…": "Loading the notifications…",
  "Chargement du bilan…": "Loading the review…",
  "Chargement du compteur PEA…": "Loading the PEA counter…",
  "Chargement du dernier rapport disponible…": "Loading the latest report available…",
  "Chargement du fantôme…": "Loading the ghost…",
  "Chargement du panel…": "Loading the panel…",
  "Chargement du portefeuille…": "Loading the portfolio…",
  "Chargement du rapport…": "Loading the report…",
  "Chargement…": "Loading…",
  "Charger les modèles": "Load the models",
  "Chiffré avant d’être stocké, jamais réaffiché.": "Encrypted before it is stored, never shown again.",
  "Chine": "China",
  "Choc pétrolier": "Oil shock",
  "Choisir les valeurs à analyser": "Choose the securities to analyse",
  "Choisir un modèle…": "Choose a model…",
  "Choisir un panel": "Choose a panel",
  "Choisir un rapport quotidien": "Choose a daily report",
  "Choisir une autre crise": "Choose another crisis",
  "Choisir…": "Choose…",
  "Choisissez la mascotte qui accompagne l’assistante dans le chat.": "Choose the mascot that goes with the assistant in the chat.",
  "Choisissez un instrument.": "Choose an instrument.",
  "Choisissez un mot de passe d’au moins 8 caractères.": "Choose a password of at least 8 characters.",
  "Choisissez une date dans le futur.": "Choose a date in the future.",
  "Choisissez une étoile.": "Choose a star.",
  "Cible": "Target",
  "Cible pour {0} (%)": "Target for {0} (%)",
  "Cibles": "Targets",
  "Cinq ans : votre PEA a atteint sa maturité fiscale.": "Five years: your PEA has reached its tax maturity.",
  "Classement": "Ranking",
  "Cliquez : elle ouvre et referme elle-même son sweat": "Click: she opens and closes her sweatshirt herself",
  "Clos": "Closed",
  "Clé API": "API key",
  "Clé API requise": "API key required",
  "Clé de l’application (App Key)": "Application key (App Key)",
  "Clé disponible sur {0}": "Key available on {0}",
  "Clé enregistrée :": "Key saved:",
  "Clé enregistrée : {0}. Laissez le champ vide pour la conserver.": "Key saved: {0}. Leave the field empty to keep it.",
  "Clôture": "Close",
  "Collez-le dans « Ajouter un calendrier par URL ».": "Paste it in “Add calendar from URL”.",
  "Communication": "Communication",
  "Comparaison indisponible.": "Comparison unavailable.",
  "Compléter": "Complete",
  "Complétez le profil de votre PEA": "Complete your PEA's profile",
  "Compte": "Account",
  "Compte :": "Account:",
  "Compte PEA BoursoBank": "BoursoBank PEA account",
  "Compte SIM": "SIM account",
  "Compte SIM réinitialisé à": "SIM account reset to",
  "Compte choisi": "Account chosen",
  "Compte de simulation": "Simulation account",
  "Compte des ordres": "Orders account",
  "Compte fictif de Saxo, avec son propre argent virtuel : idéal pour tout essayer sans risque.": "Saxo's fictitious account, with its own virtual money: ideal to try everything without risk.",
  "Compte indisponible : {0}": "Account unavailable: {0}",
  "Compte réel": "Real account",
  "Compte {0}. Le fantôme paie {1} pt de frais à votre barème ; indices de prix, dividendes ignorés.": "{0} account. The ghost pays {1} pt of fees at your fee schedule; price indices, dividends ignored.",
  "Comptes indisponibles.": "Accounts unavailable.",
  "Compteur": "Counter",
  "Concentration, volatilité et expositions à surveiller.": "Concentration, volatility and exposures to watch.",
  "Conclusion": "Conclusion",
  "Configurer les experts": "Set up the experts",
  "Configurez votre clé OpenAI ou Gemini dans les réglages pour discuter avec Gladys.": "Set your OpenAI or Gemini key in the settings to chat with Gladys.",
  "Configurez votre clé OpenAI ou Gemini dans les réglages pour générer des analyses.": "Set your OpenAI or Gemini key in the settings to generate analyses.",
  "Confinement en France.": "Lockdown in France.",
  "Confirmable à la fin de la réponse": "Can be confirmed at the end of the answer",
  "Confirmer": "Confirm",
  "Confirmer le mot de passe": "Confirm the password",
  "Confirmer une suppression": "Confirm a deletion",
  "Confirmez les avertissements.": "Acknowledge the warnings.",
  "Connecter": "Connect",
  "Connectez Saxo depuis le tableau de bord pour rechercher de nouveaux titres. Vous pouvez toujours consulter et retirer les titres enregistrés.": "Connect Saxo from the dashboard to search for new securities. You can still view and remove the saved ones.",
  "Connectez d’abord l’application réelle et choisissez le compte.": "Connect the real-money application first and choose the account.",
  "Connectez votre compte": "Connect your account",
  "Connectez votre compte {0}": "Connect your {0} account",
  "Connectez-vous avec votre application pour ouvrir la session.": "Log in with your application to open the session.",
  "Connectez-vous pour accéder à votre patrimoine.": "Log in to access your wealth.",
  "Connecté": "Connected",
  "Connectée": "Connected",
  "Connexion au micro…": "Connecting the microphone…",
  "Connexion au serveur…": "Connecting to the server…",
  "Connexion au trading…": "Connecting to trading…",
  "Connexion impossible.": "Connection failed.",
  "Connexion impossible. Vérifiez vos identifiants et réessayez.": "Connection failed. Check your credentials and try again.",
  "Connexion perdue, reconnexion…": "Connection lost, reconnecting…",
  "Connexion refusée par Saxo : {0}.": "Connection refused by Saxo: {0}.",
  "Connexion {0}": "{0} connection",
  "Connexion…": "Connecting…",
  "Conseillère classique": "Classic adviser",
  "Consensus": "Consensus",
  "Consensus d'experts": "Expert consensus",
  "Consensus, convergences et avis contradictoires": "Consensus, convergences and contradicting opinions",
  "Conserver": "Hold",
  "Conserver la clé actuelle ({0})": "Keep the current key ({0})",
  "Conserver la ligne": "Keep the line",
  "Consolidation": "Consolidation",
  "Consommation cyclique": "Consumer cyclical",
  "Consommation de base": "Consumer staples",
  "Constellation": "Constellation",
  "Constellation du portefeuille": "Portfolio constellation",
  "Content": "Happy",
  "Contenu vide.": "Empty content.",
  "Contexte :": "Context:",
  "Contexte d’analyse chargé": "Analysis context loaded",
  "Contrôles avant envoi": "Checks before sending",
  "Conversation supprimée": "Conversation deleted",
  "Conversations": "Conversations",
  "Copie impossible : sélectionnez le lien à la main.": "Copy failed: select the link by hand.",
  "Copie impossible : sélectionnez l’adresse à la main.": "Copy failed: select the address by hand.",
  "Copier le lien": "Copy the link",
  "Copier l’adresse": "Copy the address",
  "Corps de texte : la détente des rendements souverains européens se poursuit, tandis que les marchés intègrent une probabilité de baisse des taux de la BCE d’ici décembre.": "Body text: the easing of European sovereign yields continues, while markets price in a probability of an ECB rate cut by December.",
  "Corrélation moyenne": "Average correlation",
  "Corrélations des rendements quotidiens sur six mois (au moins 40 séances communes), affichées à partir de 0,3 ; en pointillés, les corrélations inverses. Secteurs : Yahoo Finance ; les fonds sont regroupés. Liquidités hors constellation :": "Correlations of daily returns over six months (at least 40 common sessions), shown from 0.3; dashed, inverse correlations. Sectors: Yahoo Finance; funds are grouped. Cash outside the constellation:",
  "Corée du Sud": "South Korea",
  "Cotation achat / vente": "Bid / ask",
  "Cotation à l’envoi": "Quote when sent",
  "Couleurs": "Colours",
  "Coupable": "Guilty",
  "Coupable : la présidente prononcera un allègement ou une vente. Non coupable : la ligne est conservée, voire renforcée. Rien ne sera passé en bourse. Sans vote d’ici un quart d’heure, la présidente tranchera seule.": "Guilty: the presiding judge will order a trim or a sale. Not guilty: the line is kept, or even reinforced. Nothing will be traded. Without a vote within a quarter of an hour, the presiding judge decides alone.",
  "Coupe-circuit": "Kill switch",
  "Coupe-circuit actif": "Kill switch on",
  "Couper la parole": "Interrupt",
  "Couper le micro": "Mute the microphone",
  "Couples les plus liés": "Most linked pairs",
  "Cours": "Price",
  "Cours demandé": "Requested price",
  "Cours du second ordre": "Second order's price",
  "Cours limite": "Limit price",
  "Cours limite du second ordre": "Second order's limit price",
  "Courtage": "Brokerage",
  "Courtier": "Broker",
  "Couverture partielle des sources.": "Partial coverage of the sources.",
  "Covid-19": "Covid-19",
  "Coût du glissement": "Slippage cost",
  "Coût par an": "Cost per year",
  "Crise des dettes souveraines": "Sovereign debt crisis",
  "Crise financière": "Financial crisis",
  "Croissance": "Growth",
  "Croissance du dividende": "Dividend growth",
  "Création impossible.": "Creation failed.",
  "Créer mon compte": "Create my account",
  "Créer un compte": "Create an account",
  "Créer votre compte": "Create your account",
  "Créez une application « Code » avec le droit de trading sur le portail développeur Saxo.": "Create a “Code” application with trading rights on the Saxo developer portal.",
  "Créé": "Created",
  "C’est déjà le cas": "Already the case",
  "C’est à vous de juger.": "It is up to you.",
  "Danemark": "Denmark",
  "Dans dix ans :": "In ten years:",
  "Dans {0} an{1}": "In {0} year{1}",
  "Date": "Date",
  "Date d'ouverture": "Opening date",
  "Date de clôture": "Closing date",
  "Date de détachement": "Ex-dividend date",
  "Date de paiement": "Payment date",
  "Date du rapport": "Report date",
  "Date d’ouverture": "Opening date",
  "Date d’échéance manquante.": "Expiry date missing.",
  "Date indisponible": "Date unavailable",
  "Dates du calendrier Yahoo Finance, parfois estimées. Un briefing arrive deux jours avant, une analyse le soir de la publication.": "Dates from the Yahoo Finance calendar, sometimes estimated. A briefing arrives two days before, an analysis on the evening of the release.",
  "De 2 à 60.": "From 2 to 60.",
  "De la plus proche à la plus lointaine.": "From the closest to the furthest.",
  "De vos placements": "Of your investments",
  "Demander un nouveau lien": "Ask for a new link",
  "Depuis la veille": "Since yesterday",
  "Depuis le": "Since",
  "Depuis le {0}, {1} débat{2} : le panel (toutes ses décisions) {3}, le CAC 40 {4}.": "Since {0}, {1} debate{2}: the panel (all its decisions) {3}, the CAC 40 {4}.",
  "Depuis, votre portefeuille a évolué de": "Since then, your portfolio has moved by",
  "Dernier rapport": "Latest report",
  "Derniers ordres clos": "Latest closed orders",
  "Dernière réinitialisation le {0}.": "Last reset on {0}.",
  "Dernières décisions du panel : {0}.": "Latest panel decisions: {0}.",
  "Des analyses à la demande de votre portefeuille, rédigées par l’IA.": "On-demand analyses of your portfolio, written by AI.",
  "Des subprimes à la faillite de Lehman Brothers : le CAC 40 perd plus de la moitié de sa valeur avant de rebondir.": "From the subprimes to the collapse of Lehman Brothers: the CAC 40 loses more than half its value before rebounding.",
  "Design system · dev uniquement": "Design system · dev only",
  "Dessiner la BD de ce numéro": "Draw this issue's comic strip",
  "Deux tiers": "Two thirds",
  "Devient": "Becomes",
  "Devient un ordre au marché quand le cours atteint le seuil.": "Becomes a market order when the price reaches the trigger.",
  "Devise": "Currency",
  "Devises": "Currencies",
  "Dirigeants": "Executives",
  "Distance au marché": "Distance to the market",
  "Diversification": "Diversification",
  "Diversification : nombre effectif de lignes (un ETF compte pour cinq), pénalité au-delà de 25 % sur une action. Frugalité : frais annuels de la page Frais & fiscalité, 100 à 0,10 % par an ou moins, 0 à 1 % ou plus. Sang-froid : part des baisses du CAC 40 de 1,5 % ou plus des douze derniers mois traversées sans vendre dans les trois jours, plus les pauses prises sur Garder son calme. Appétit : versement mensuel programmé et achats récents. Un jeu, pas une note de gestion.": "Diversification: effective number of lines (an ETF counts as five), penalty above 25 % on one share. Frugality: yearly fees from the Fees & tax page, 100 at 0.10 % a year or less, 0 at 1 % or more. Composure: share of the CAC 40 falls of 1.5 % or more over the last twelve months crossed without selling within three days, plus the pauses taken on Keep calm. Appetite: monthly deposit scheduled and recent purchases. A game, not a management grade.",
  "Dividende des douze derniers mois par action, rendement au cours actuel et sur votre prix de revient.": "Dividend of the last twelve months per share, yield at the current price and on your cost price.",
  "Dividendes": "Dividends",
  "Dividendes mensuels": "Monthly dividends",
  "Dividendes perçus": "Dividends received",
  "Dividendes réinvestis (doré) ou dépensés (gris), à rendement constant.": "Dividends reinvested (gold) or spent (grey), at a constant yield.",
  "Dividendes versés en {0}": "Dividends paid in {0}",
  "Données en cache": "Cached data",
  "Données publiques du régulateur : positions courtes publiées et opérations des dirigeants sur six mois.": "Public data from the regulator: published short positions and executives' transactions over six months.",
  "Drawdown max": "Max drawdown",
  "Droits de garde": "Custody fees",
  "Du {0} au {1}": "From {0} to {1}",
  "Durée": "Duration",
  "Durée (jours)": "Duration (days)",
  "Durée de détention": "Holding period",
  "Durée de la baisse": "Length of the fall",
  "Durée de l’appel": "Call duration",
  "Dès que le rapport du matin est prêt, avec sa première ligne.": "As soon as the morning report is ready, with its first line.",
  "Débat": "Debate",
  "Débat du": "Debate of",
  "Débat du {0}": "Debate of {0}",
  "Débat d’experts": "Expert debate",
  "Débat d’experts sur {0}": "Expert debate on {0}",
  "Débat en direct": "Live debate",
  "Débat lancé sur {0}": "Debate started on {0}",
  "Débat relu : {0} ordre{1} préparé{2}": "Debate read again: {0} order{1} prepared",
  "Débat sur {0} du {1}": "Debate on {0} of {1}",
  "Débat à la demande": "On-demand debate",
  "Débat à la demande ·": "On-demand debate ·",
  "Débats": "Debates",
  "Débats d’experts": "Expert debates",
  "Déboutonne son chemisier au survol": "Unbuttons her blouse on hover",
  "Début": "Start",
  "Décision": "Decision",
  "Décisions du rapport du {0}, prises à froid.": "Decisions of the report of {0}, taken in cold blood.",
  "Décisions justes": "Right decisions",
  "Décisions récentes": "Recent decisions",
  "Déclaration {0} sur le site de l’AMF": "{0} declaration on the AMF website",
  "Déclarez l’adresse de retour indiquée dans les réglages.": "Declare the redirect address shown in the settings.",
  "Déclencheur": "Trigger",
  "Déclencheurs du panel": "Panel triggers",
  "Déclencheurs sans proposition d’achat": "Triggers without a buy proposal",
  "Défavorable (1 sur 10)": "Unfavourable (1 in 10)",
  "Défense": "Defence",
  "Définissez d’abord vos cibles ci-dessus : le versement est réparti vers les lignes sous leur cible.": "Set your targets above first: the deposit goes to the lines below their target.",
  "Définissez vos cibles": "Set your targets",
  "Déjà ajouté": "Already added",
  "Déjà un compte ?": "Already have an account?",
  "Délai d’annulation": "Cancellation delay",
  "Démarrage de la recherche.": "Starting the research.",
  "Démarrer": "Start",
  "Démarré le (heure de Paris)": "Started on (Paris time)",
  "Démo onglets": "Tabs demo",
  "Démo pilules": "Pills demo",
  "Déplier le menu": "Expand the menu",
  "Désactiver sur cet appareil": "Disable on this device",
  "Désactivé": "Disabled",
  "Désactivées": "Disabled",
  "Désarmer le déclencheur de {0}": "Disarm the trigger of {0}",
  "Détachement": "Ex-dividend",
  "Détail de l’ordre {0} : {1}": "Detail of order {0}: {1}",
  "Détail du panel": "Panel detail",
  "Détail par ligne": "Detail per line",
  "Détenue en direct": "Held directly",
  "D’où viennent les frais": "Where the fees come from",
  "D’où vient le détail de chaque fonds.": "Where each fund's detail comes from.",
  "ETF Europe": "Europe ETF",
  "ETF défense": "Defence ETF",
  "ETF indice US": "US index ETF",
  "Effacer": "Clear",
  "Effacer la recherche": "Clear the search",
  "Effet de levier compris": "Leverage included",
  "Email non envoyé": "Email not sent",
  "Email ou mot de passe incorrect.": "Invalid email or password.",
  "En % de vos placements.": "In % of your investments.",
  "En % du compte, liquidités comprises (en euros).": "In % of the account, cash included (in euros).",
  "En attendant le {0}": "While waiting for {0}",
  "En attente de la prochaine intervention…": "Waiting for the next speaker…",
  "En attente des rumeurs de chaque valeur avant de générer la synthèse…": "Waiting for each holding's rumours before writing the summary…",
  "En bref": "In short",
  "En carnet": "In the book",
  "En cours": "In progress",
  "En cours :": "In progress:",
  "En cours ou interrompu": "In progress or interrupted",
  "En direct": "Live",
  "En direct · {0}": "Live · {0}",
  "En discuter avec Gladys": "Discuss it with Gladys",
  "En désaccord": "Disagrees",
  "En envoi différé ou automatique, le pilote passera de vrais ordres sans vous demander de confirmer chacun. Les garde-fous et le coupe-circuit restent actifs.": "In delayed or automatic sending, the pilot will place real orders without asking you to confirm each one. The guard rails and the kill switch stay active.",
  "En file d'attente…": "Queued…",
  "En gain": "In profit",
  "En liquidités": "As cash",
  "En parler avant d’agir": "Talk about it before acting",
  "En parler à Gladys": "Talk to Gladys about it",
  "En pause": "Paused",
  "En perte": "At a loss",
  "En points de base (20 = 0,20 %) au-dessus du milieu pour un achat.": "In basis points (20 = 0.20 %) above the mid for a buy.",
  "En portefeuille": "In the portfolio",
  "En semaine, heure de Paris. Hors de ces heures : pas d’ordre au marché.": "On weekdays, Paris time. Outside these hours: no market order.",
  "En tête": "Leading",
  "Enfant": "Child",
  "Engagé par le pilote (achats − ventes)": "Committed by the pilot (buys − sells)",
  "Engagé par le pilote (au plus haut)": "Committed by the pilot (at its peak)",
  "Enregistrer": "Save",
  "Enregistrer le barème": "Save the fee schedule",
  "Enregistrer le mot de passe": "Save the password",
  "Enregistrer le panel": "Save the panel",
  "Enregistrer les limites": "Save the limits",
  "Enregistrer l’expert": "Save the expert",
  "Enregistrer l’objectif": "Save the goal",
  "Enregistrer mes identifiants": "Save my credentials",
  "Enregistrez d’abord une clé API pour charger les modèles disponibles.": "Save an API key first to load the available models.",
  "Entreprises": "Companies",
  "Entrer (ou sortir) en plusieurs fois pour lisser le prix : un total découpé en tranches, envoyées automatiquement par le planificateur pendant les heures de marché.": "Enter (or exit) in several steps to smooth the price: a total cut into slices, sent automatically by the scheduler during market hours.",
  "Entrée": "Entry",
  "Entrée pour envoyer le contexte, ou posez une question précise…": "Enter to send the context, or ask a precise question…",
  "Enveloppe du pilote": "Pilot's envelope",
  "Environnement": "Environment",
  "Environnement actif": "Active environment",
  "Environnement de trading": "Trading environment",
  "Envoi automatique": "Automatic sending",
  "Envoi différé": "Delayed sending",
  "Envoi différé : temps minimum entre l’annonce et l’envoi.": "Delayed sending: minimum time between the notice and the sending.",
  "Envoi impossible.": "Sending failed.",
  "Envoi par email": "Email delivery",
  "Envoi sans confirmation en argent réel autorisé le {0}.": "Real-money sending without confirmation allowed on {0}.",
  "Envoi…": "Sending…",
  "Envoyer": "Send",
  "Envoyer cet ordre en SIM ?": "Send this order in SIM?",
  "Envoyer en réel": "Send for real",
  "Envoyer le lien": "Send the link",
  "Envoyer le panier": "Send the basket",
  "Envoyer l’ordre": "Send the order",
  "Envoyer un test": "Send a test",
  "Envoyé": "Sent",
  "Envoyé par email": "Sent by email",
  "Envoyés, en carnet, programmés ou proposés à votre confirmation.": "Sent, in the book, scheduled or proposed for your confirmation.",
  "Envoyés, en carnet, programmés ou proposés.": "Sent, in the book, scheduled or proposed.",
  "Erronée": "Wrong",
  "Espagne": "Spain",
  "Estimation : les lignes des ETF viennent de Yahoo Finance (le fonds lui-même, sinon un fonds américain du même indice), la répartition par pays et devise d’un fonds vient de son indice (ordre de grandeur des fiches émetteurs). Un ETF à effet de levier compte pour son exposition économique (×2). Le pays d’une action est celui de son émetteur.": "Estimate: the ETFs' lines come from Yahoo Finance (the fund itself, else a US fund of the same index), a fund's split by country and currency comes from its index (order of magnitude of the issuers' factsheets). A leveraged ETF counts for its economic exposure (×2). A share's country is its issuer's.",
  "Estimation des revenus…": "Estimating the income…",
  "Estimation indicative selon les règles en vigueur en 2026, hors taux historiques des prélèvements sociaux et cas particuliers. Ce n’est pas un conseil fiscal.": "Indicative estimate under the 2026 rules, without the historical social contribution rates and special cases. This is not tax advice.",
  "Estimation à partir des dividendes des douze derniers mois (Yahoo Finance, date de détachement ; le versement suit de quelques jours). Les dividendes futurs ne sont pas garantis ; la croissance passée est indicative.": "Estimate from the dividends of the last twelve months (Yahoo Finance, ex-dividend date; the payment follows a few days later). Future dividends are not guaranteed; past growth is indicative.",
  "Estimation, pas une prévision : sensibilités mesurées du": "An estimate, not a forecast: sensitivities measured from",
  "Euros": "Euros",
  "Examiner": "Review",
  "Exclu": "Excluded",
  "Exclure": "Exclude",
  "Exclure de l'analyse (rapports quotidiens)": "Exclude from the analysis (daily reports)",
  "Exclure de l'analyse dans les rapports quotidiens": "Exclude from the analysis in the daily reports",
  "Exclure {0} de l'analyse": "Exclude {0} from the analysis",
  "Exemple de dialogue accessible : piège à focus, Échap, clic extérieur.": "Accessible dialog example: focus trap, Escape, outside click.",
  "Expert ajouté": "Expert added",
  "Expert enregistré": "Expert saved",
  "Expert supprimé": "Expert deleted",
  "Experts": "Experts",
  "Experts ayant analysé": "Experts who analysed",
  "Expiré": "Expired",
  "Exporter CSV": "Export CSV",
  "Exposition réelle": "Real exposure",
  "Exposition réelle (ETF ouverts)": "Real exposure (ETFs opened up)",
  "Exposition économique": "Economic exposure",
  "Extrait du rapport": "Report excerpt",
  "Exécution": "Execution",
  "Exécuté": "Executed",
  "Exécuté seulement à ce cours ou mieux.": "Executed only at this price or better.",
  "Exécuté tout de suite au meilleur prix disponible.": "Executed at once at the best available price.",
  "FIFO (premier entré, premier sorti)": "FIFO (first in, first out)",
  "Facteur de profit": "Profit factor",
  "Faillite de Lehman Brothers.": "Collapse of Lehman Brothers.",
  "Fait": "Done",
  "Fantôme": "Ghost",
  "Fantôme (toutes les décisions)": "Ghost (every decision)",
  "Fantôme, pilote et vous": "Ghost, pilot and you",
  "Fatigué": "Tired",
  "Favorable (1 sur 10)": "Favourable (1 in 10)",
  "Fermer": "Close",
  "Fermer la notification": "Close the notification",
  "Fermer la session": "Close the session",
  "Fermer le menu": "Close the menu",
  "Fermer l’historique": "Close the history",
  "Fil d'Ariane": "Breadcrumb",
  "Fil du débat": "Debate thread",
  "Filtrer les positions": "Filter the positions",
  "Filtrer par impact": "Filter by impact",
  "Filtrer par valeur": "Filter by holding",
  "Filtrer par état": "Filter by status",
  "Fin": "End",
  "Fin de la crise": "End of the crisis",
  "Finance": "Finance",
  "Finlande": "Finland",
  "Fixez une allocation cible : les ordres suggérés respectent les contraintes du PEA (actions entières, pas de marge, réserve de liquidités).": "Set a target allocation: the suggested orders follow the PEA's constraints (whole shares, no margin, cash reserve).",
  "Flux nets": "Net flows",
  "Fonds": "Funds",
  "Forfait annuel saisi.": "Yearly fee entered.",
  "Formulaires": "Forms",
  "Fournisseur": "Provider",
  "Fournisseur d’IA": "AI provider",
  "Fournisseur et modèle utilisés pour les analyses, les actualités et Gladys.": "Provider and model used for the analyses, the news and Gladys.",
  "Frais & fiscalité": "Fees & tax",
  "Frais courants": "Ongoing charges",
  "Frais courants des ETF et retenue à la source des dividendes étrangers, avec des ETF éligibles au PEA moins chers sur le même indice quand il y en a.": "ETF ongoing charges and withholding tax on foreign dividends, with cheaper PEA-eligible ETFs on the same index when there are some.",
  "Frais courants inconnus pour": "Ongoing charges unknown for",
  "Frais courants prélevés dans la valeur des fonds.": "Ongoing charges taken from the funds' value.",
  "Frais de change": "FX fees",
  "Frais de courtage payés :": "Brokerage fees paid:",
  "Frais des ETF": "ETF fees",
  "Frais estimés": "Estimated fees",
  "Frais estimés (Saxo)": "Estimated fees (Saxo)",
  "Frais estimés par Saxo": "Fees estimated by Saxo",
  "Frais estimés payés": "Estimated fees paid",
  "Frais fixes par ordre": "Fixed fee per order",
  "Frais par ligne": "Fees per line",
  "Frais payés : {0} pt.": "Fees paid: {0} pt.",
  "Frais proportionnels": "Proportional fees",
  "Franchise fiscale acquise": "Tax exemption acquired",
  "Gagnantes": "Winners",
  "Gain moyen": "Average gain",
  "Gain net imposable (tout le plan)": "Taxable net gain (whole plan)",
  "Gains et pertes": "Gains and losses",
  "Garde-fous": "Guard rails",
  "Garde-fous du pilote": "Pilot's guard rails",
  "Garde-fous passés": "Guard rails passed",
  "Garde-fous passés, valeur estimée": "Guard rails passed, estimated value",
  "Garde-fous à l’envoi": "Guard rails when sent",
  "Garder": "Keep",
  "Garder son calme": "Keep calm",
  "Gestion de patrimoine": "Wealth management",
  "Gestion de patrimoine PEA": "PEA wealth management",
  "Gladys :": "Gladys:",
  "Gladys connaît votre portefeuille et le dernier rapport : exposez-lui ce qui vous inquiète.": "Gladys knows your portfolio and the latest report: tell her what worries you.",
  "Gladys dort": "Gladys is asleep",
  "Gladys est agitée": "Gladys is restless",
  "Gladys est détendue": "Gladys is relaxed",
  "Gladys est sereine": "Gladys is serene",
  "Gladys est songeuse": "Gladys is thoughtful",
  "Gladys manga animée (Spine) : 5 expressions, physique du buste et des cheveux": "Animated manga Gladys (Spine): 5 expressions, bust and hair physics",
  "Gladys n’a pas pu répondre.": "Gladys could not answer.",
  "Gladys rayonne": "Gladys is beaming",
  "Gladys réfléchit…": "Gladys is thinking…",
  "Gladys se repose": "Gladys is resting",
  "Gladys vous fait signe": "Gladys is waving at you",
  "Gladys vous répond": "Gladys answers you",
  "Gladys, votre assistante, pour chaque question": "Gladys, your assistant, for every question",
  "Glissement": "Slippage",
  "Glissement moyen": "Average slippage",
  "Grand": "Large",
  "Graphiques": "Charts",
  "Graphite profond, or champagne mat, Fraunces pour les titres et Inter pour les données.": "Deep graphite, matte champagne gold, Fraunces for titles and Inter for data.",
  "Général": "General",
  "Génération de la synthèse à partir de {0}…": "Generating the summary from {0}…",
  "Génération en cours…": "Generating…",
  "Génération lancée": "Generation started",
  "Génération lancée : le rapport du jour sera remplacé (consensus d'experts si au moins deux experts sont activés) puis renvoyé par email. Cela peut prendre plusieurs minutes.": "Generation started: today's report will be replaced (expert consensus if at least two experts are enabled) then emailed again. This can take several minutes.",
  "Génération…": "Generating…",
  "Générer la synthèse": "Generate the summary",
  "Générer un nouveau rapport": "Generate a new report",
  "Généré le (heure de Paris)": "Generated on (Paris time)",
  "Générée le": "Generated on",
  "Gérer la watchlist": "Manage the watchlist",
  "Hausse des taux": "Rate rise",
  "Heure d’envoi": "Sending time",
  "Heure d’exécution": "Execution time",
  "Heure par défaut": "Default time",
  "Heures de trading": "Trading hours",
  "Historique": "History",
  "Historique de dividendes indisponible pour": "Dividend history unavailable for",
  "Historique de la crise indisponible.": "The crisis history is unavailable.",
  "Historique de performance du courtier indisponible.": "Broker performance history unavailable.",
  "Historique de rendements": "Return history",
  "Historique de vos lignes, borné entre −5 et 10 %.": "History of your lines, bounded between −5 and 10 %.",
  "Historique des analyses": "Analysis history",
  "Historique des conversations": "Conversation history",
  "Historique des marchés indisponible pour le moment : la projection ne peut pas être calculée.": "Market history unavailable for now: the projection cannot be computed.",
  "Historique des marchés indisponible.": "Market history unavailable.",
  "Historique des panels": "Panel history",
  "Historique des rapports quotidiens": "Daily report history",
  "Historique insuffisant.": "Not enough history.",
  "Horizon d’évaluation": "Assessment horizon",
  "Identifiant de panel invalide.": "Invalid panel identifier.",
  "Identifiant de rapport invalide.": "Invalid report identifier.",
  "Identifiants enregistrés": "Credentials saved",
  "Identifiants {0}": "{0} credentials",
  "Idées du panel par mois": "Panel ideas per month",
  "Ignorer": "Ignore",
  "Ignorée": "Ignored",
  "Il faut au moins deux experts actifs. Trois procès par jour au plus ; chaque audience coûte quelques appels à leurs modèles.": "At least two active experts are needed. Three trials a day at most; each hearing costs a few calls to their models.",
  "Il les envoie à l’heure choisie, après un délai pendant lequel vous pouvez annuler.": "It sends them at the chosen time, after a delay during which you can cancel.",
  "Il les envoie à l’heure choisie, sans attendre. Le coupe-circuit arrête tout.": "It sends them at the chosen time, without waiting. The kill switch stops everything.",
  "Il prépare les ordres, vous confirmez chacun dans la salle des ordres.": "It prepares the orders, you confirm each one in the order room.",
  "Il se construit à partir des rapports du panel d’experts : il faut au moins deux experts actifs et un premier rapport.": "It is built from the expert panel's reports: at least two active experts and a first report are needed.",
  "Il vous devance de": "It is ahead of you by",
  "Ils s’écrivent automatiquement autour des publications de vos lignes, avec votre clé d’IA (ou celle du rapporteur du panel).": "They are written automatically around your lines' releases, with your AI key (or the panel rapporteur's).",
  "Image téléchargée": "Image downloaded",
  "Immobilier": "Real estate",
  "Impact": "Impact",
  "Impact estimé de quatre scénarios, d’après la sensibilité historique de vos lignes sur un an.": "Estimated impact of four scenarios, from your lines' historical sensitivity over a year.",
  "Impact neutre": "Neutral impact",
  "Impact négatif": "Negative impact",
  "Impact positif": "Positive impact",
  "Impossible d'ajouter ce titre.": "Unable to add this security.",
  "Impossible de calculer les frais.": "Unable to compute the fees.",
  "Impossible de calculer l’exposition.": "Unable to compute the exposure.",
  "Impossible de changer le mode de vote.": "Unable to change the voting mode.",
  "Impossible de charger ce débat.": "Unable to load this debate.",
  "Impossible de charger ce panel.": "Unable to load this panel.",
  "Impossible de charger ce rapport.": "Unable to load this report.",
  "Impossible de charger cette édition.": "Unable to load this edition.",
  "Impossible de charger l'historique des panels.": "Unable to load the panel history.",
  "Impossible de charger l'historique des rapports.": "Unable to load the report history.",
  "Impossible de charger la configuration des experts.": "Unable to load the experts' configuration.",
  "Impossible de charger la conversation.": "Unable to load the conversation.",
  "Impossible de charger la page.": "Unable to load the page.",
  "Impossible de charger la performance": "Unable to load the performance",
  "Impossible de charger le bilan du panel.": "Unable to load the panel's scorecard.",
  "Impossible de charger le compteur PEA.": "Unable to load the PEA counter.",
  "Impossible de charger le portefeuille fantôme.": "Unable to load the ghost portfolio.",
  "Impossible de charger les conversations.": "Unable to load the conversations.",
  "Impossible de charger les débats.": "Unable to load the debates.",
  "Impossible de charger les experts.": "Unable to load the experts.",
  "Impossible de charger les modèles.": "Unable to load the models.",
  "Impossible de charger les notifications.": "Unable to load the notifications.",
  "Impossible de charger les résultats.": "Unable to load the results.",
  "Impossible de charger les éditions.": "Unable to load the editions.",
  "Impossible de charger l’objectif.": "Unable to load the goal.",
  "Impossible de créer l’image dans ce navigateur.": "Unable to create the image in this browser.",
  "Impossible de dessiner la BD.": "Unable to draw the comic strip.",
  "Impossible de désactiver les notifications sur cet appareil.": "Unable to disable notifications on this device.",
  "Impossible de lancer la génération du rapport.": "Unable to start the report generation.",
  "Impossible de lancer le débat.": "Unable to start the debate.",
  "Impossible de lire l’allocation cible enregistrée.": "Unable to read the saved target allocation.",
  "Impossible de mettre à jour l'exclusion": "Unable to update the exclusion",
  "Impossible de programmer le rappel.": "Unable to schedule the reminder.",
  "Impossible de préparer votre année.": "Unable to prepare your year.",
  "Impossible de renouveler le lien.": "Unable to renew the link.",
  "Impossible de retirer ce titre.": "Unable to remove this security.",
  "Impossible de retirer le déclencheur.": "Unable to remove the trigger.",
  "Impossible de réactiver le trading.": "Unable to resume trading.",
  "Impossible de supprimer la conversation.": "Unable to delete the conversation.",
  "Impossible de supprimer l’expert.": "Unable to delete the expert.",
  "Impossible de tracer la constellation.": "Unable to draw the constellation.",
  "Impossible de vider le cache": "Unable to clear the cache",
  "Impossible d’activer le coupe-circuit.": "Unable to turn on the kill switch.",
  "Impossible d’activer les notifications sur cet appareil.": "Unable to enable notifications on this device.",
  "Impossible d’actualiser le portefeuille": "Unable to refresh the portfolio",
  "Impossible d’ajouter ce titre": "Unable to add this security",
  "Impossible d’annuler le rappel.": "Unable to cancel the reminder.",
  "Impossible d’enregistrer ce réglage.": "Unable to save this setting.",
  "Impossible d’enregistrer le barème.": "Unable to save the fee schedule.",
  "Impossible d’enregistrer le panel.": "Unable to save the panel.",
  "Impossible d’enregistrer le pilote.": "Unable to save the pilot.",
  "Impossible d’enregistrer le profil PEA.": "Unable to save the PEA profile.",
  "Impossible d’enregistrer le résultat de l’action.": "Unable to save the action's result.",
  "Impossible d’enregistrer le versement.": "Unable to save the deposit.",
  "Impossible d’enregistrer les limites.": "Unable to save the limits.",
  "Impossible d’enregistrer les préférences.": "Unable to save the preferences.",
  "Impossible d’enregistrer les réglages. Veuillez réessayer.": "Unable to save the settings. Please try again.",
  "Impossible d’enregistrer l’allocation cible.": "Unable to save the target allocation.",
  "Impossible d’enregistrer l’expert.": "Unable to save the expert.",
  "Impossible d’enregistrer l’objectif.": "Unable to save the goal.",
  "Impossible d’envoyer la notification de test.": "Unable to send the test notification.",
  "Impossible d’envoyer l’email de réinitialisation. Veuillez réessayer.": "Unable to send the reset email. Please try again.",
  "Impossible d’estimer les revenus.": "Unable to estimate the income.",
  "Impossible d’ouvrir le procès.": "Unable to open the trial.",
  "Impossible d’écarter la proposition.": "Unable to dismiss the proposal.",
  "Imprimer ou PDF": "Print or PDF",
  "Impôt sur le revenu ({0})": "Income tax ({0})",
  "Impôt étranger sur les dividendes, non récupérable dans un PEA.": "Foreign tax on dividends, not recoverable in a PEA.",
  "Incident": "Incident",
  "Incident signalé": "Incident reported",
  "Inclure les montants": "Include the amounts",
  "Inclut le changement de courtier.": "Includes the change of broker.",
  "Inconnu": "Unknown",
  "Inde": "India",
  "Indicateurs": "Indicators",
  "Indice de prix, dividendes ignorés. Une enveloppe part de 100 en liquidités et ne s’endette jamais ; une nouvelle ligne de la watchlist pèse 3 %.": "Price index, dividends ignored. An envelope starts at 100 in cash and never borrows; a new watchlist line weighs 3 %.",
  "Indice de prix, hors dividendes : avec les dividendes réinvestis, les reprises sont plus rapides. Un marché baissier commence à −20 % depuis un sommet et se termine par un rebond de 20 % ; le retour au plus haut se mesure depuis le creux. Le passé ne garantit rien, il donne l’ordre de grandeur.": "Price index, dividends excluded: with dividends reinvested, recoveries are faster. A bear market starts at −20 % from a peak and ends with a 20 % rebound; the return to the high is measured from the trough. The past guarantees nothing, it gives the order of magnitude.",
  "Indice non reconnu : composition non détaillée.": "Index not recognised: composition not detailed.",
  "Indice {0} : répartition par pays et devise, sans le détail des lignes.": "{0} index: split by country and currency, without the line-by-line detail.",
  "Indices de comparaison": "Comparison indices",
  "Indiquez la clé de l’application.": "Enter the application's key.",
  "Indiquez la date d’ouverture dans le profil.": "Enter the opening date in the profile.",
  "Indiquez le montant de votre versement mensuel.": "Enter the amount of your monthly deposit.",
  "Indiquez un montant en euros.": "Enter an amount in euros.",
  "Indiquez vos versements cumulés dans le profil.": "Enter your cumulative deposits in the profile.",
  "Indisponible": "Unavailable",
  "Indisponible :": "Unavailable:",
  "Industrie": "Industry",
  "Inflation et hausse des taux": "Inflation and rate hikes",
  "Info": "Info",
  "Initialisation de la recherche d'actualités…": "Starting the news search…",
  "Inscription impossible. Veuillez réessayer.": "Sign-up failed. Please try again.",
  "Inscriptions fermées": "Sign-up closed",
  "Installer PEA Wallet": "Install PEA Wallet",
  "Installez PEA Wallet pour l’ouvrir comme une application, en plein écran.": "Install PEA Wallet to open it like an app, full screen.",
  "Installée": "Installed",
  "Instruction du dossier": "Preparing the case",
  "Instrument": "Instrument",
  "Instrument (symbole exact)": "Instrument (exact symbol)",
  "Instruments trouvés": "Instruments found",
  "Intelligence": "Intelligence",
  "Intelligence artificielle": "Artificial intelligence",
  "Interrupteur": "Switch",
  "Intrajournalière": "Intraday",
  "Intérêt faible": "Low interest",
  "Intérêt fort": "Strong interest",
  "Intérêt moyen": "Medium interest",
  "Investi": "Invested",
  "Investisseur": "Investor",
  "Investisseur particulier": "Private investor",
  "Irlande": "Ireland",
  "Isolé sur {0}": "Alone on {0}",
  "Issue des arbitrages": "Outcome of the arbitrations",
  "Italie": "Italy",
  "Jamais entamée par un achat.": "Never dipped into by a purchase.",
  "Japon": "Japan",
  "Je confirme ce programme sur mon compte réel : ses tranches partiront sans nouvelle confirmation.": "I confirm this programme on my real account: its slices will be sent without further confirmation.",
  "Je confirme ces ordres sur mon compte réel.": "I confirm these orders on my real account.",
  "Je confirme cet ordre sur mon compte réel.": "I confirm this order on my real account.",
  "Je confirme cette modification sur mon compte réel.": "I confirm this change on my real account.",
  "Je note votre question…": "Noting your question…",
  "Je réfléchis…": "Thinking…",
  "Je viens de générer ce rapport d'analyse : « {0} » Voici l'analyse : {1}{2} Apporte-moi des éclairages complémentaires, réponds à mes questions et propose les prochaines étapes.": "I just generated this analysis report: “{0}” Here is the analysis: {1}{2} Give me further insights, answer my questions and suggest the next steps.",
  "Je vous écoute…": "I'm listening…",
  "Jeu de l’esprit, pas un conseil : le passé ne se rejoue pas et les futurs simulés ne sont pas des prévisions.": "A thought experiment, not advice: the past does not replay and the simulated futures are not forecasts.",
  "Jour": "Day",
  "Jour du versement": "Deposit day",
  "Journal d'audit": "Audit log",
  "Journal du fantôme": "Ghost's journal",
  "Journal d’audit": "Audit log",
  "Journal indisponible.": "Journal unavailable.",
  "Jours de bourse": "Trading days",
  "Jury": "Jury",
  "Jusqu’au…": "Until…",
  "Jusqu’à annulation": "Until cancelled",
  "Jusqu’à une minute selon le modèle.": "Up to a minute depending on the model.",
  "Juste": "Right",
  "J’ai envie de vendre dans l’urgence. Aide-moi à prendre du recul avant de décider.": "I feel like selling in a hurry. Help me step back before deciding.",
  "J’ai fini": "I'm done",
  "J’ai vérifié, je confirme": "I have checked, I confirm",
  "J’ai vérifié, valable pour toutes les tranches": "I have checked, valid for every slice",
  "Krach boursier": "Market crash",
  "L'éligibilité au PEA doit être vérifiée avant tout achat.": "PEA eligibility must be checked before any purchase.",
  "LIFO (dernier entré, premier sorti)": "LIFO (last in, first out)",
  "La BCE prête près de 500 milliards d'euros aux banques.": "The ECB lends nearly 500 billion euros to the banks.",
  "La BD de la nuit": "The night comic strip",
  "La Grèce, puis l'Italie et l'Espagne inquiètent ; les États-Unis perdent leur note AAA.": "Greece, then Italy and Spain worry the markets; the United States lose their AAA rating.",
  "La Russie envahit l'Ukraine.": "Russia invades Ukraine.",
  "La clé, le secret et la session sont effacés. Le journal des ordres reste.": "The key, the secret and the session are erased. The order journal stays.",
  "La connexion a été interrompue avant la fin de la réponse.": "The connection was interrupted before the end of the answer.",
  "La connexion actuelle de l’app est en lecture seule. Pour passer des ordres, créez votre propre application sur le portail développeur Saxo (en simulation d’abord), puis enregistrez sa clé ici.": "The app's current connection is read-only. To place orders, create your own application on the Saxo developer portal (in simulation first), then save its key here.",
  "La constellation apparaît dès que votre portefeuille contient des lignes.": "The constellation appears as soon as your portfolio holds lines.",
  "La consultation et l'actualisation ne déclenchent aucune analyse ni recherche Tavily.": "Viewing and refreshing never trigger an analysis or a Tavily search.",
  "La date d’ouverture et le total de vos versements activent le compteur du plafond, la date des 5 ans et le simulateur de retrait.": "The opening date and the total of your deposits enable the ceiling counter, the five-year date and the withdrawal simulator.",
  "La guerre en Ukraine fait flamber l'énergie ; les banques centrales relèvent leurs taux à marche forcée.": "The war in Ukraine sends energy soaring; central banks raise their rates at a forced pace.",
  "La génération du rapport a échoué : {0}": "Report generation failed: {0}",
  "La génération prend plus de temps que prévu : elle se poursuit peut-être en arrière-plan. Actualisez dans quelques minutes.": "The generation is taking longer than expected: it may be continuing in the background. Refresh in a few minutes.",
  "La moitié dépasse": "Half go over",
  "La pause automatique se règle dans les limites de risque des réglages trading.": "The automatic pause is set in the trading settings' risk limits.",
  "La position de chaque expert, notée comme celle du panel.": "Each expert's position, scored like the panel's.",
  "La position de chaque expert, notée comme celle du panel. La voix est le poids de son vote quand le vote pondéré est activé (Réglages › Experts).": "Each expert's position, scored like the panel's. The voice is the weight of their vote when weighted voting is on (Settings › Experts).",
  "La présidente": "The presiding judge",
  "La recherche est indisponible. Vérifiez la connexion Saxo et réessayez.": "Search is unavailable. Check the Saxo connection and try again.",
  "La synthèse vocale a échoué dans ce navigateur : Gladys répond par écrit.": "Speech synthesis failed in this browser: Gladys answers in writing.",
  "La transcription a échoué.": "Transcription failed.",
  "La variation de votre compte n’est pas disponible pour l’instant : le courtier ne répond pas ou aucun relevé de la veille n’existe.": "Your account's change is not available for now: the broker does not answer or no statement from the day before exists.",
  "Laboratoire": "Laboratory",
  "Laboratoire · Le Procès": "Laboratory · The Trial",
  "Laissez vide pour garder le secret enregistré.": "Leave empty to keep the saved secret.",
  "Lancer le débat": "Start the debate",
  "Lancer l’analyse": "Start the analysis",
  "Lancer une analyse": "Start an analysis",
  "Langue (interface et IA)": "Language (interface and AI)",
  "Langue de l’interface et des contenus IA": "Language of the interface and the AI content",
  "Langue des contenus IA": "AI content language",
  "Lanterne rouge : {0} {1}": "Bottom of the class: {0} {1}",
  "Le": "The",
  "Le Brent dépasse 130 dollars le baril.": "Brent goes above 130 dollars a barrel.",
  "Le CAC 40 :": "The CAC 40:",
  "Le CAC 40 est à": "The CAC 40 is at",
  "Le CAC 40 perd 9 % en une séance.": "The CAC 40 loses 9 % in one session.",
  "Le CAC 40 progresse de 10 %.": "The CAC 40 rises by 10 %.",
  "Le CAC 40 recule de 20 %.": "The CAC 40 falls by 20 %.",
  "Le Journal": "The Journal",
  "Le Journal de votre PEA": "Your PEA's Journal",
  "Le PEA est fait pour durer : sa fiscalité récompense le temps.": "The PEA is made to last: its taxation rewards time.",
  "Le Procès": "The Trial",
  "Le baril de Brent bondit de 40 %.": "The Brent barrel jumps by 40 %.",
  "Le bilan se construit à partir des rapports d’experts : il faut au moins deux experts actifs dans le panel.": "The scorecard is built from the expert reports: at least two active experts are needed in the panel.",
  "Le changement de courtier s’applique à l’enregistrement des réglages.": "The change of broker applies when the settings are saved.",
  "Le compte SIM est parti de votre portefeuille réel le {0} : le pilote le gère depuis, le Bilan le mesure à partir de cette date.": "The SIM account started from your real portfolio on {0}: the pilot has managed it since, the Review measures it from that date.",
  "Le compte SIM n’a jamais été réinitialisé depuis le réel.": "The SIM account has never been reset from the real one.",
  "Le compte SIM n’est pas encore une copie de votre portefeuille réel : réinitialisez-le pour que le pilote parte de vos lignes et de la valeur exacte de votre PEA.": "The SIM account is not yet a copy of your real portfolio: reset it so the pilot starts from your lines and your PEA's exact value.",
  "Le compte SIM repart de votre portefeuille réel : ses positions sont soldées, ses ordres et achats étalés arrêtés, puis chaque ligne de votre PEA est achetée au marché. Une ligne introuvable dans le SIM ou une fraction de titre reste en liquidités : le compte SIM vaut exactement votre PEA. Marché fermé, la réinitialisation se fait à l’ouverture. Votre compte réel n’est pas touché.": "The SIM account starts again from your real portfolio: its positions are closed, its orders and staggered buys stopped, then each line of your PEA is bought at market. A line not found in the SIM or a fraction of a share stays in cash: the SIM account is worth exactly your PEA. With the market closed, the reset happens at the opening. Your real account is not touched.",
  "Le compte SIM, géré par le pilote, depuis sa réinitialisation du {0} : sa valeur face à votre compte réel, au fantôme et au CAC 40, tous ramenés à 0 ce jour-là.": "The SIM account, managed by the pilot, since its reset on {0}: its value against your real account, the ghost and the CAC 40, all brought back to 0 that day.",
  "Le compte de trading en direct : cours, variation du jour, ordres en cours. Mis à jour toutes les quelques secondes.": "The live trading account: prices, day's change, open orders. Updated every few seconds.",
  "Le contenu de ce rapport est vide.": "This report's content is empty.",
  "Le dernier rapport, écrit avant l’ouverture.": "The latest report, written before the opening.",
  "Le débat": "The debate",
  "Le fantôme depuis le départ": "The ghost since the start",
  "Le fantôme n’a encore rien suivi": "The ghost has not followed anything yet",
  "Le glissement compare le prix obtenu au milieu de fourchette au moment de l’envoi (positif = payé plus cher).": "Slippage compares the price obtained with the mid of the spread when the order was sent (positive = paid more).",
  "Le greffe rassemble le dossier : recherches du jour, positions, signaux AMF…": "The clerk gathers the case file: the day's research, positions, AMF signals…",
  "Le journal reprend le rapport du matin : il paraîtra avec le premier rapport.": "The journal takes the morning report: it will come out with the first report.",
  "Le jury a déclaré la ligne": "The jury declared the line",
  "Le jury délibère": "The jury is deliberating",
  "Le krach le plus rapide de l'histoire, puis un rebond porté par les banques centrales et les vaccins.": "The fastest crash in history, then a rebound carried by central banks and vaccines.",
  "Le marché est fermé.": "The market is closed.",
  "Le mieux calibré": "Best calibrated",
  "Le mot de passe doit contenir au moins 8 caractères.": "The password must contain at least 8 characters.",
  "Le même retrait de": "The same withdrawal of",
  "Le navigateur a bloqué la voix de Gladys.": "The browser blocked Gladys' voice.",
  "Le panel (moyenne des experts) : Brier": "The panel (the experts' mean): Brier",
  "Le panel d’experts": "The expert panel",
  "Le panel n’a fixé aucun seuil de repli actif sur votre watchlist. Ils apparaissent après chaque rapport quotidien.": "The panel has set no active pullback level on your watchlist. They appear after each daily report.",
  "Le panel recherche l’actualité de la valeur, chaque expert l’analyse, puis la table ronde tranche et le rapporteur conclut. Le débat se suit en direct et utilise les clés de vos experts.": "The panel looks up the security's news, each expert analyses it, then the round table decides and the rapporteur concludes. The debate can be followed live and uses your experts' keys.",
  "Le panel vous aurait fait gagner {0} points.": "The panel would have earned you {0} points.",
  "Le pilote autonome décidera seul et passera de vrais ordres sans vous demander de confirmer chacun. Les garde-fous et le coupe-circuit restent actifs.": "The autonomous pilot will decide alone and place real orders without asking you to confirm each one. The guard rails and the kill switch stay active.",
  "Le pilote gère le compte SIM comme son propre portefeuille : il s’éloigne du réel à mesure qu’il suit le panel. Les lignes qu’il est seul à détenir sont analysées chaque matin par le panel, comme la watchlist, et revendues quand son intérêt devient faible.": "The pilot manages the SIM account as its own portfolio: it moves away from the real one as it follows the panel. The lines only it holds are analysed every morning by the panel, like the watchlist, and sold again when its interest becomes low.",
  "Le pilote lira le prochain débat quotidien terminé, ou relisez le dernier.": "The pilot will read the next completed daily debate, or read the latest one again.",
  "Le pilote ne lit pas les débats.": "The pilot does not read the debates.",
  "Le pilote n’a encore préparé aucun ordre.": "The pilot has not prepared any order yet.",
  "Le pilote n’a pas pu relire le débat.": "The pilot could not read the debate again.",
  "Le plafond de versements de votre PEA est atteint : plus aucun versement n’est possible.": "Your PEA's deposit ceiling is reached: no more deposits are possible.",
  "Le plan du jour sera écrit par {0}, avec son propre modèle et sa clé, après chaque débat quotidien terminé.": "The day's plan will be written by {0}, with their own model and key, after each completed daily debate.",
  "Le plan reste ouvert": "The plan stays open",
  "Le plus dur : {0} {1}": "The hardest: {0} {1}",
  "Le rappel arrive en notification si elles sont activées sur un appareil (Réglages › Notifications) ; sinon, revenez sur cette page demain.": "The reminder arrives as a notification if they are enabled on a device (Settings › Notifications); otherwise, come back to this page tomorrow.",
  "Le rapport du jour sera remplacé puis renvoyé par email.": "Today's report will be replaced then emailed again.",
  "Le rapport du matin mis en page comme la une d’un quotidien financier, à lire ou à imprimer.": "The morning report laid out like the front page of a financial daily, to read or print.",
  "Le rapport du {0} en quatre cases, scénarisé par l’IA, dessiné par l’application.": "The report of {0} in four panels, scripted by the AI, drawn by the app.",
  "Le rapport d’experts nécessite au moins": "The expert report needs at least",
  "Le rapport quotidien, résumé en cinq lignes.": "The daily report, summed up in five lines.",
  "Le rapport standard a été utilisé si une clé IA générale est configurée.": "The standard report was used if a general AI key is set.",
  "Le rapporteur lit le rapport, le débat et tout le compte, puis décide seul des ordres du jour : quoi, combien, type, stops, étalement, heure. Envoi sans confirmation, chaque ordre contrôlé par le code.": "The rapporteur reads the report, the debate and the whole account, then decides the day's orders alone: what, how much, type, stops, staggering, time. Sent without confirmation, each order checked by the code.",
  "Le rapporteur rédige un projet commun ; chaque autre expert l'approuve ou émet des réserves, intégrées ou listées comme divergences dans le rapport final.": "The rapporteur writes a joint draft; each other expert approves it or raises reservations, included or listed as disagreements in the final report.",
  "Le rendement de votre compte est indisponible (courtier non connecté) : seuls le fantôme et le CAC 40 sont comparés.": "Your account's return is unavailable (broker not connected): only the ghost and the CAC 40 are compared.",
  "Le récapitulatif a besoin des données de votre courtier pour cette année.": "The recap needs your broker's data for this year.",
  "Le récapitulatif de l’année : performance, mois marquants, opérations, dividendes, sang-froid et décisions du panel.": "The year's recap: performance, standout months, trades, dividends, composure and panel decisions.",
  "Le réel demande une application réelle connectée et un compte choisi.": "Real money needs a connected real application and a chosen account.",
  "Le rôle des audiences": "The role of the hearings",
  "Le serveur a refusé la requête.": "The server refused the request.",
  "Le serveur ne répond pas : l’état de la connexion sera vérifié dès son retour.": "The server does not answer: the connection state will be checked as soon as it is back.",
  "Le serveur ne répond pas pour le moment. Nouvelle tentative automatique toutes les 10 secondes.": "The server does not answer for now. Automatic retry every 10 seconds.",
  "Le serveur n’a pas répondu.": "The server did not answer.",
  "Le seuil suit le cours à distance fixe, et ne recule jamais.": "The threshold follows the price at a fixed distance, and never moves back.",
  "Le simulateur a besoin de la valeur du compte et de vos versements cumulés.": "The simulator needs the account's value and your cumulative deposits.",
  "Le simulateur rejoue les lignes de votre portefeuille : il en faut au moins une.": "The simulator replays the lines of your portfolio: it needs at least one.",
  "Le statut du trading est indisponible.": "The trading status is unavailable.",
  "Le tribunal est indisponible.": "The court is unavailable.",
  "Le virus gagne l'Italie : les marchés décrochent.": "The virus reaches Italy: markets drop.",
  "Lecture du débat du {0}": "Reading the debate of {0}",
  "Lecture du rapport quotidien": "Reading the daily report",
  "Lecture du verdict": "Reading the verdict",
  "Lectures précédentes": "Previous readings",
  "Les actualités de vos positions et de votre watchlist.": "The news of your positions and your watchlist.",
  "Les analyses et débats apparaissent ici après chaque génération du rapport quotidien.": "The analyses and debates appear here after each daily report generation.",
  "Les chiffres du jour": "Today's figures",
  "Les cibles et la réserve totalisent {0} % : le reste ira aux liquidités ou aux lignes hors plan.": "The targets and the reserve add up to {0} %: the rest will go to cash or to lines outside the plan.",
  "Les cibles et la réserve totalisent {0} %, au-delà de 100 %.": "The targets and the reserve add up to {0} %, above 100 %.",
  "Les cinq premières positions par valorisation": "The top five positions by value",
  "Les dividendes apparaissent ici dès qu’ils sont programmés par votre courtier.": "Dividends appear here as soon as your broker schedules them.",
  "Les dix écarts les plus marqués": "The ten widest gaps",
  "Les données sont rechargées depuis le courtier.": "The data is reloaded from the broker.",
  "Les décisions de chaque expert sont comparées ligne par ligne : les accords unanimes sont actés d'office, une nette majorité tranche sans débat, les points de friction sont soumis à la table ronde.": "Each expert's decisions are compared line by line: unanimous agreements are adopted outright, a clear majority decides without debate, points of friction go to the round table.",
  "Les déclencheurs proposeront des achats": "The triggers will propose purchases",
  "Les experts annoncent leurs probabilités à chaque débat quotidien : les premières seront notées 20 séances plus tard.": "The experts state their probabilities at every daily debate: the first ones will be scored 20 sessions later.",
  "Les experts interviennent à tour de rôle sur les seuls points ouverts ; chacun fait évoluer ou maintient sa position en la motivant.": "The experts speak in turn on the open points only; each changes or keeps their position and gives reasons.",
  "Les exécutions les plus coûteuses": "The costliest executions",
  "Les fortes variations de cette ligne ces derniers jours, et leur cause dans l’actualité.": "This line's sharp moves over the last days, and their cause in the news.",
  "Les fortes variations de vos lignes en séance, expliquées par l’actualité du jour. Le seuil se règle dans Réglages › Notifications.": "Your lines' sharp intraday moves, explained by the day's news. The threshold is set in Settings › Notifications.",
  "Les futurs possibles de votre PEA, et les univers parallèles où vous auriez fait d’autres choix.": "Your PEA's possible futures, and the parallel universes where you would have made other choices.",
  "Les garde-fous et Saxo vérifient la modification avant qu’elle ne s’applique.": "The guard rails and Saxo check the change before it applies.",
  "Les grandes baisses passées et ce qui a suivi, calculées sur les clôtures depuis 1990.": "The great falls of the past and what followed, computed on the closes since 1990.",
  "Les inscriptions sont fermées.": "Sign-up is closed.",
  "Les lignes vendues ces cinq dernières années apparaîtront ici.": "The lines sold over the last five years will appear here.",
  "Les marchés dorment aussi.": "Markets sleep too.",
  "Les marchés mondiaux plongent.": "World markets plunge.",
  "Les marchés sont fermés ce week-end.": "Markets are closed this weekend.",
  "Les mots de passe ne correspondent pas.": "The passwords do not match.",
  "Les notifications sont bloquées pour ce site : autorisez-les dans les réglages du navigateur, puis réessayez.": "Notifications are blocked for this site: allow them in the browser settings, then try again.",
  "Les notifications sont refusées pour ce site : autorisez-les dans les réglages du navigateur, puis réessayez.": "Notifications are denied for this site: allow them in the browser settings, then try again.",
  "Les ordres partent sur votre compte réel. Chaque ordre demande une confirmation explicite.": "Orders go to your real account. Each order needs an explicit confirmation.",
  "Les ordres partiront sur votre vrai compte. Les garde-fous restent actifs, et chaque ordre demandera encore votre confirmation.": "Orders will go to your real account. The guard rails stay active, and each order will still need your confirmation.",
  "Les paires dont les cours bougent le plus ensemble.": "The pairs whose prices move together the most.",
  "Les positions sont comparées ligne par ligne : les accords sont actés d’office, les points de friction passent en table ronde modérée par le rapporteur. Celui-ci rédige ensuite le rapport commun, que chaque autre expert approuve ou assortit de réserves. Les désaccords persistants restent visibles dans le rapport final.": "Positions are compared line by line: agreements are adopted outright, points of friction go to a round table moderated by the rapporteur. The rapporteur then writes the joint report, which each other expert approves or qualifies with reservations. Persistent disagreements stay visible in the final report.",
  "Les prochains dividendes apparaissent dès que votre courtier les a programmés.": "Upcoming dividends appear as soon as your broker has scheduled them.",
  "Les retraits ne libèrent pas de plafond.": "Withdrawals do not free ceiling room.",
  "Les seuils de repli fixés par le panel sur votre watchlist, en cibles. Armer une cible prépare un achat à cours limité au seuil, valable jusqu’à annulation : il s’exécute seulement si le cours y descend.": "The pullback levels set by the panel on your watchlist, as targets. Arming a target prepares a limit buy at the level, valid until cancelled: it only executes if the price comes down to it.",
  "Les stops de protection et objectifs liés à vos lignes restent actifs chez Saxo.": "The protective stops and targets attached to your lines stay active at Saxo.",
  "Les taux longs montent de 1 point.": "Long rates rise by 1 point.",
  "Les trajectoires possibles": "The possible paths",
  "Les tranches déjà envoyées restent dans le journal ; aucune autre ne partira.": "The slices already sent stay in the journal; no other will be sent.",
  "Les univers parallèles sont injoignables pour le moment.": "The parallel universes cannot be reached for now.",
  "Les valeurs suivies, au cours du compte de trading.": "The tracked securities, at the trading account's prices.",
  "Les versements s’arrêtent au plafond du PEA (il reste {0} à verser).": "Deposits stop at the PEA ceiling ({0} left to deposit).",
  "Les votes du panel suivent l’arène": "The panel's votes follow the arena",
  "Les votes suivent le bilan des experts": "The votes follow the experts' scorecard",
  "Les écarts restent sous l’ordre minimal ou les liquidités ne permettent pas d’acheter.": "The gaps stay below the minimum order or the cash does not allow buying.",
  "Levier ×": "Leverage ×",
  "Leçon de l’année": "Lesson of the year",
  "Libellé": "Label",
  "Libellé eyebrow · valeur totale": "Eyebrow label · total value",
  "Lien copié": "Link copied",
  "Lien d’abonnement au calendrier": "Calendar subscription link",
  "Ligne": "Line",
  "Ligne la plus lourde": "Heaviest line",
  "Ligne par ligne": "Line by line",
  "Ligne {0} du portefeuille. Audience ouverte le {1}.": "Portfolio line {0}. Hearing opened on {1}.",
  "Ligne à juger": "Line on trial",
  "Lignes": "Lines",
  "Lignes désignées": "Designated lines",
  "Lignes détenues": "Lines held",
  "Lignes effectives": "Effective lines",
  "Lignes en devise étrangère hors totaux :": "Foreign-currency lines outside the totals:",
  "Lignes ouvertes sur une idée du jour, hors portefeuille et watchlist, seulement sur un intérêt fort à l’unanimité. 0 = jamais.": "Lines opened on an idea of the day, outside the portfolio and watchlist, only on a unanimous strong interest. 0 = never.",
  "Limite": "Limit",
  "Limite ± 0,3 %": "Limit ± 0.3 %",
  "Limites de risque": "Risk limits",
  "Limites enregistrées": "Limits saved",
  "Liquidités": "Cash",
  "Liquidités :": "Cash:",
  "Liquidités après": "Cash after",
  "Liquidités après l’achat": "Cash after the purchase",
  "Liquidités comprises": "Cash included",
  "Liquidités et investi": "Cash and invested",
  "Lire le dernier rapport": "Read the latest report",
  "Lire le rapport": "Read the report",
  "Lire le rapport complet": "Read the full report",
  "Lire le rapport global": "Read the global report",
  "Lire le rapport global consolidé": "Read the consolidated global report",
  "Liste noire": "Blacklist",
  "Liée à": "Linked to",
  "Loin de l’ouverture et de la clôture, où la fourchette est la plus large.": "Away from the opening and the close, where the spread is widest.",
  "Loin de l’ouverture et de la clôture, où la fourchette est large.": "Away from the opening and the close, where the spread is wide.",
  "Légende": "Legend",
  "L’action a échoué.": "The action failed.",
  "L’affaire {0}": "The {0} case",
  "L’ancien lien cessera de fonctionner : il faudra réabonner vos agendas.": "The old link will stop working: you will need to subscribe your calendars again.",
  "L’angle que l’IA doit privilégier": "The angle the AI should favour",
  "L’année en accéléré · rendement cumulé": "The year in fast-forward · cumulative return",
  "L’arène s’ouvre après les premiers débats quotidiens du panel.": "The arena opens after the panel's first daily debates.",
  "L’audience a été interrompue.": "The hearing was interrupted.",
  "L’autre vous, passif, fait mieux.": "The other you, passive, does better.",
  "L’autre vous, qui n’a pas vendu": "The other you, who did not sell",
  "L’autre vous, qui suit le panel": "The other you, who follows the panel",
  "L’autre vous, tout en ETF monde": "The other you, all in world ETFs",
  "L’essentiel du jour": "Today's essentials",
  "L’essentiel en 5 lignes": "The essentials in 5 lines",
  "L’exposition apparaît dès que votre portefeuille contient des lignes.": "The exposure appears as soon as your portfolio holds lines.",
  "L’histoire du CAC 40": "The story of the CAC 40",
  "L’historique du CAC 40 est indisponible pour le moment.": "The CAC 40 history is unavailable for now.",
  "L’univers où chaque décision du panel d’experts est appliquée à la lettre.": "The universe where each decision of the expert panel is applied to the letter.",
  "Macro": "Macro",
  "Mais l’argent retiré ne pourra pas être reversé : le plafond de versements ne se reconstitue pas.": "But the money withdrawn cannot be paid back in: the deposit ceiling does not refill.",
  "Majorité": "Majority",
  "Mal en point": "In bad shape",
  "Manuel": "Manual",
  "Marché fermé": "Market closed",
  "Marché fermé : la simulation sera réinitialisée le {0}, au cours de l’ouverture.": "Market closed: the simulation will be reset on {0}, at the opening price.",
  "Marché fermé : {0}.": "Market closed: {0}.",
  "Marché ouvert": "Market open",
  "Marché trop agité, besoin de recul…": "Market too agitated, need to step back…",
  "Marchés baissiers du CAC 40 depuis 1990": "CAC 40 bear markets since 1990",
  "Marque": "Brand",
  "Mascotte": "Mascot",
  "Mascotte enregistrée": "Mascot saved",
  "Masquer": "Hide",
  "Masquer Gladys": "Hide Gladys",
  "Masquer la clé": "Hide the key",
  "Masquer le déclencheur de {0}": "Hide the trigger of {0}",
  "Masquer les montants": "Hide the amounts",
  "Masquer l’erreur": "Hide the error",
  "Match nul : le fantôme et vous êtes au coude à coude.": "A draw: the ghost and you are neck and neck.",
  "Matrice de convergence et ordre du jour": "Convergence matrix and agenda",
  "Matériaux": "Materials",
  "Max": "Max",
  "Me rappeler les achats le jour du versement": "Remind me of the purchases on deposit day",
  "Meilleur conseil du panel": "The panel's best advice",
  "Meilleur mois": "Best month",
  "Meilleure : {0} {1}": "Best: {0} {1}",
  "Meilleure séance": "Best session",
  "Meilleure valeur": "Best security",
  "Membre depuis": "Member since",
  "Menu principal": "Main menu",
  "Mesdames et Messieurs les jurés": "Ladies and gentlemen of the jury",
  "Message": "Message",
  "Message à Gladys": "Message to Gladys",
  "Mettre en pause": "Pause",
  "Mettre en procès": "Put on trial",
  "Mettre le trading en pause": "Pause trading",
  "Mexique": "Mexico",
  "Micro coupé": "Microphone muted",
  "Minimum par ordre": "Minimum per order",
  "Mis en page par PEA Wallet à partir du rapport du matin. Ceci n’est pas un conseil en investissement.": "Laid out by PEA Wallet from the morning report. This is not investment advice.",
  "Mis à jour le": "Updated on",
  "Mise sous presse…": "Going to press…",
  "Mise à jour à {0}": "Updated at {0}",
  "Mode du pilote": "Pilot mode",
  "Mode sniper": "Sniper mode",
  "Modification impossible.": "Change failed.",
  "Modifier l’ordre": "Modify the order",
  "Modifier {0}": "Edit {0}",
  "Modifiez la recherche ou le filtre d'impact.": "Change the search or the impact filter.",
  "Modifiez la recherche ou le filtre pour afficher d’autres lignes.": "Change the search or the filter to show other lines.",
  "Modifiez les valeurs : la projection se met à jour.": "Change the values: the projection updates.",
  "Modèle": "Model",
  "Modération de l'ordre du jour": "Agenda moderation",
  "Moins bonne valeur": "Worst security",
  "Mois le plus dur": "Hardest month",
  "Mon PEA": "My PEA",
  "Mon PEA est-il bien diversifié ?": "Is my PEA well diversified?",
  "Mon année": "My year",
  "Mon année {0}": "My year {0}",
  "Mon compte": "My account",
  "Mon compte : {0} % aujourd’hui.": "My account: {0} % today.",
  "Monde": "World",
  "Montant": "Amount",
  "Montant de cession": "Sale amount",
  "Montant des versements invalide.": "Invalid deposit amount.",
  "Montant du retrait": "Withdrawal amount",
  "Montant estimé": "Estimated amount",
  "Montant masqué": "Amount hidden",
  "Montant maximum par jour": "Maximum amount per day",
  "Montant maximum par ordre": "Maximum amount per order",
  "Montant net perçu": "Net amount received",
  "Montant retiré": "Amount withdrawn",
  "Montant récupéré (plan entier)": "Amount recovered (whole plan)",
  "Montant réduit à": "Amount reduced to",
  "Montant total": "Total amount",
  "Montant versé chaque mois": "Amount deposited each month",
  "Montant visé": "Target amount",
  "Montants masqués (mode discret)": "Amounts hidden (discreet mode)",
  "Montants rapides": "Quick amounts",
  "Mot de passe": "Password",
  "Mot de passe modifié": "Password changed",
  "Mot de passe modifié.": "Password changed.",
  "Mot de passe oublié ?": "Forgot your password?",
  "Multivers": "Multiverse",
  "Médian": "Median",
  "Méthode de clôture": "Closing method",
  "Météo du portefeuille": "Portfolio weather",
  "Même en versant tout le plafond restant, l’objectif n’est pas atteint dans 8 cas sur 10.": "Even depositing all the remaining ceiling, the goal is not reached in 8 cases out of 10.",
  "Navigation": "Navigation",
  "Navigation principale": "Main navigation",
  "Net par an": "Net per year",
  "Neutre": "Neutral",
  "Neutres": "Neutral",
  "Niveaux fixés par le rapport du {0} sur votre watchlist, surveillés toutes les 15 minutes en séance. Aucun ordre n’est passé.": "Levels set by the report of {0} on your watchlist, watched every 15 minutes during the session. No order is placed.",
  "Nom": "Name",
  "Nom ou symbole : ASML, TotalEnergies, LQQ…": "Name or symbol: ASML, TotalEnergies, LQQ…",
  "Nom ou symbole : Air Liquide, CW8, AI:xpar…": "Name or symbol: Air Liquide, CW8, AI:xpar…",
  "Nombre de lignes égales qui donneraient la même concentration.": "Number of equal lines that would give the same concentration.",
  "Nombre de tranches": "Number of slices",
  "Nombre entier de titres au cours du seuil, dans cette limite.": "Whole number of shares at the level's price, within this limit.",
  "Nombre entier de titres au cours du seuil. Le ticket reste à vérifier et confirmer.": "Whole number of shares at the level's price. The ticket still has to be checked and confirmed.",
  "Nombre maximal d’experts atteint (": "Maximum number of experts reached (",
  "Nombre total de titres": "Total number of shares",
  "Non configuré": "Not set up",
  "Non configurée": "Not set up",
  "Non connecté": "Not connected",
  "Non connectée": "Not connected",
  "Non coupable": "Not guilty",
  "Non disponible": "Not available",
  "Non détaillé": "Not detailed",
  "Non notée": "Not scored",
  "Non renseigné": "Not filled in",
  "Norvège": "Norway",
  "Notification": "Notification",
  "Notification de test envoyée": "Test notification sent",
  "Notifications": "Notifications",
  "Notifications activées sur cet appareil": "Notifications enabled on this device",
  "Notifications désactivées sur cet appareil": "Notifications disabled on this device",
  "Nous avons envoyé un lien de réinitialisation à": "We sent a reset link to",
  "Nous ne partagerons jamais votre adresse.": "We will never share your address.",
  "Nouveau lien créé": "New link created",
  "Nouveau mot de passe": "New password",
  "Nouveau programme": "New programme",
  "Nouveau rapport généré.": "New report generated.",
  "Nouvel expert": "New expert",
  "Nouvelle analyse": "New analysis",
  "Nouvelle clé": "New key",
  "Nouvelle conversation": "New conversation",
  "Négatives": "Negative",
  "Objectif": "Goal",
  "Objectif (vente à cours limité)": "Target (limit sell)",
  "Objectif atteint dans 8 cas sur 10 sans aucun versement.": "Goal reached in 8 cases out of 10 without any deposit.",
  "Objectif enregistré": "Goal saved",
  "Obligation": "Bond",
  "Opportunités": "Opportunities",
  "Opérations": "Trades",
  "Opérations clôturées": "Closed trades",
  "Opérations gagnantes": "Winning trades",
  "Opérations perdantes": "Losing trades",
  "Opérations soldées": "Closed trades",
  "Orage": "Storm",
  "Ordre": "Order",
  "Ordre annulé": "Order cancelled",
  "Ordre bloqué par les garde-fous.": "Order blocked by the guard rails.",
  "Ordre du jour": "Agenda",
  "Ordre du jour établi par le panel": "Agenda set by the panel",
  "Ordre du jour — modéré par {0}": "Agenda — moderated by {0}",
  "Ordre en argent réel": "Real-money order",
  "Ordre envoyé : {0}": "Order sent: {0}",
  "Ordre minimal": "Minimum order",
  "Ordre minimal (€)": "Minimum order (€)",
  "Ordre modifié": "Order modified",
  "Ordre n° {0}{1}": "Order no. {0}{1}",
  "Ordre passé au marché": "Order placed at market",
  "Ordre préparé : {0}": "Order prepared: {0}",
  "Ordres": "Orders",
  "Ordres des 12 derniers mois au barème saisi.": "Orders of the last 12 months at the entered fee schedule.",
  "Ordres du panier": "Basket orders",
  "Ordres du pilote": "Pilot orders",
  "Ordres du pilote exécutés": "Pilot orders executed",
  "Ordres en cours": "Open orders",
  "Ordres en devise étrangère.": "Foreign-currency orders.",
  "Ordres exécutés": "Executed orders",
  "Ordres indisponibles.": "Orders unavailable.",
  "Ordres liés (facultatif)": "Linked orders (optional)",
  "Ordres suggérés": "Suggested orders",
  "Ordres à cours limité au milieu de fourchette ± cet écart.": "Limit orders at the mid of the spread ± this gap.",
  "Origine": "Origin",
  "Oublier": "Forget",
  "Oublier l’application {0} ?": "Forget the {0} application?",
  "Ouvert le {0}": "Opened on {0}",
  "Ouverture": "Opening",
  "Ouverture de l’audience…": "Opening the hearing…",
  "Ouverture des portails…": "Opening the portals…",
  "Ouvrir Mon PEA": "Open My PEA",
  "Ouvrir dans Calendrier (Apple)": "Open in Calendar (Apple)",
  "Ouvrir de nouvelles lignes": "Open new lines",
  "Ouvrir le menu": "Open the menu",
  "Ouvrir le portefeuille fantôme": "Open the ghost portfolio",
  "Ouvrir le procès": "Open the trial",
  "Ouvrir le ticket": "Open the ticket",
  "Ouvrir les réglages": "Open the settings",
  "Ouvrir un dialogue": "Open a dialog",
  "Ouvrir une audience": "Open a hearing",
  "Où votre PEA peut vous mener : {0} trajectoires tirées de l’histoire des marchés, avec vos versements.": "Where your PEA can take you: {0} paths drawn from market history, with your deposits.",
  "PEA Wallet est installée": "PEA Wallet is installed",
  "PEA Wallet, tableau de bord": "PEA Wallet, dashboard",
  "PRU": "Avg. cost",
  "Pages": "Pages",
  "Paiement": "Payment",
  "Palette de commandes": "Command palette",
  "Palette de recherche": "Search palette",
  "Panel": "Panel",
  "Panel du {0}": "Panel of {0}",
  "Panel d’experts": "Expert panel",
  "Panel enregistré": "Panel saved",
  "Panel incomplet : {0} expert{1} actif{2} sur {3} requis.": "Incomplete panel: {0} active expert{1} out of {3} required.",
  "Panel introuvable ou non accessible.": "Panel not found or not accessible.",
  "Panel prêt : {0} experts actifs.": "Panel ready: {0} active experts.",
  "Panier envoyé": "Basket sent",
  "Panier envoyé : {0} ordre{1}": "Basket sent: {0} order{1}",
  "Panier envoyé : {0} ordre{1} parti{2}, {3} achat{4} après les ventes": "Basket sent: {0} order{1} sent, {3} purchase{4} after the sales",
  "Par décision": "By decision",
  "Par défaut, un dixième de la distance.": "By default, a tenth of the distance.",
  "Par expert": "By expert",
  "Par heure d’envoi": "By sending time",
  "Par origine": "By origin",
  "Par type d’ordre": "By order type",
  "Par valorisation des lignes": "By line value",
  "Par valorisation, liquidités comprises": "By value, cash included",
  "Parler à Gladys": "Talk to Gladys",
  "Parler à Gladys. {0}. {1}": "Talk to Gladys. {0}. {1}",
  "Part de chaque poche dans la valeur totale": "Share of each pocket in the total value",
  "Part de chaque secteur dans le montant investi.": "Share of each sector in the invested amount.",
  "Part de plus-value": "Gain share",
  "Part du compte que le pilote peut engager (par débat, et en achats cumulés).": "Share of the account the pilot can commit (per debate, and in cumulative purchases).",
  "Part du plafond utilisée": "Share of the ceiling used",
  "Partager votre année": "Share your year",
  "Participe au rapport quotidien": "Takes part in the daily report",
  "Partiel": "Partial",
  "Partir de l’actuelle": "Start from the current one",
  "Pas": "Step",
  "Pas assez d’historique commun pour mesurer les corrélations.": "Not enough common history to measure the correlations.",
  "Pas cotée à l’époque : elle suit le CAC 40 multiplié par son bêta de l’année écoulée.": "Not listed at the time: it follows the CAC 40 multiplied by its beta of the past year.",
  "Pas d’explication dans l’actualité du jour.": "No explanation in today's news.",
  "Pas d’historique de cours : corrélations inconnues.": "No price history: correlations unknown.",
  "Pas encore assez de débats quotidiens terminés pour simuler.": "Not enough completed daily debates yet to simulate.",
  "Pas encore de branche : la première se décide au passage à l’enfance.": "No branch yet: the first one is decided on reaching childhood.",
  "Pas encore de compte ?": "No account yet?",
  "Pas encore de débats quotidiens à comparer.": "No daily debates to compare yet.",
  "Pas encore de décision à évaluer": "No decision to assess yet",
  "Pas encore de match": "No match yet",
  "Pas encore d’édition": "No edition yet",
  "Passage à {0} appliqué après « Enregistrer », en bas de page.": "Switch to {0} applied after “Save”, at the bottom of the page.",
  "Passe en revue mes opérations clôturées": "Review my closed trades",
  "Passer au marché": "Go to market",
  "Passer ces ordres": "Place these orders",
  "Passer en argent réel": "Switch to real money",
  "Passer un ordre": "Place an order",
  "Patrimoine": "Wealth",
  "Patrimoine · Marchés · Décisions": "Wealth · Markets · Decisions",
  "Pause": "Pause",
  "Pause après pertes consécutives": "Pause after consecutive losses",
  "Pause automatique": "Automatic pause",
  "Pays": "Countries",
  "Pays d’émission inconnu pour": "Issuing country unknown for",
  "Pays-Bas": "Netherlands",
  "Peine :": "Sentence:",
  "Perdantes": "Losers",
  "Performance": "Performance",
  "Performance de la valeur et du CAC 40 sur {0} séances, depuis la clôture précédant le rapport.": "Performance of the security and the CAC 40 over {0} sessions, since the close before the report.",
  "Performance, risques et pistes d’amélioration sur l’ensemble du portefeuille.": "Performance, risks and areas for improvement across the whole portfolio.",
  "Perte moyenne": "Average loss",
  "Petit": "Small",
  "Phase 2": "Phase 2",
  "Phase 3": "Phase 3",
  "Phase 3 · débat": "Phase 3 · debate",
  "Phase 3 · issue": "Phase 3 · outcome",
  "Phase 4": "Phase 4",
  "Pilote": "Pilot",
  "Pilote (SIM)": "Pilot (SIM)",
  "Pilote (compte SIM)": "Pilot (SIM account)",
  "Pilote (réel)": "Pilot (real)",
  "Pilote (vos réglages)": "Pilot (your settings)",
  "Pilote du panel": "Panel pilot",
  "Pilote désactivé": "Pilot off",
  "Pilote en argent réel": "Real-money pilot",
  "Pilote enregistré": "Pilot saved",
  "Pilote indisponible.": "Pilot unavailable.",
  "Pire moment": "Worst moment",
  "Pire séance": "Worst session",
  "Pire séance :": "Worst session:",
  "Pire séance de l'histoire du CAC 40 : −12 %.": "Worst session in the CAC 40's history: −12 %.",
  "Pistes de croissance et lignes à renforcer.": "Growth ideas and lines to reinforce.",
  "Pistes d’action concrètes": "Concrete courses of action",
  "Placements": "Investments",
  "Placés avec l’achat, actifs dès son exécution, valables jusqu’à annulation.": "Placed with the purchase, active once it is executed, valid until cancelled.",
  "Plafond de versements": "Deposit ceiling",
  "Plafond des versements": "Deposit ceiling",
  "Plafond des versements, antériorité fiscale et simulation de retrait.": "Deposit ceiling, tax seniority and withdrawal simulation.",
  "Plafond légal des versements sur la vie du plan.": "Legal ceiling of deposits over the plan's life.",
  "Plafond utilisé": "Ceiling used",
  "Plan de versement indisponible.": "Deposit plan unavailable.",
  "Planification": "Planning",
  "Plans de sauvetage des banques : le CAC 40 gagne 11 % en une séance.": "Bank rescue plans: the CAC 40 gains 11 % in one session.",
  "Plateforme de trading professionnelle": "Professional trading platform",
  "Plein écran": "Full screen",
  "Pluie": "Rain",
  "Plus aucun ordre ne partira, quelle que soit son origine, jusqu’à ce que vous repreniez la main.": "No order will be sent any more, whatever its origin, until you take back control.",
  "Plus beau coup": "Best move",
  "Plus-value": "Capital gain",
  "Plus-value du plan": "Plan's gain",
  "Plus-value latente": "Unrealised gain",
  "Plus/moins-value": "Gain/loss",
  "Plus/moins-value %": "Gain/loss %",
  "Plus/moins-values": "Gains/losses",
  "Plus/moins-values par ligne": "Gains/losses per line",
  "Plutôt négatif": "Rather negative",
  "Plutôt positif": "Rather positive",
  "Poids": "Weight",
  "Poids des votes du panel": "Weight of the panel's votes",
  "Poids d’une nouvelle ligne": "Weight of a new line",
  "Poids en % de chaque compte, liquidités comprises (réel {0}, SIM {1}).": "Weight in % of each account, cash included (real {0}, SIM {1}).",
  "Poids maximum d’une ligne": "Maximum weight of a line",
  "Poids visé par ligne, en % de la valeur totale. Une ligne sans cible reste telle quelle.": "Target weight per line, in % of the total value. A line without a target stays as it is.",
  "Point bas du CAC 40, sous les 2 600 points.": "The CAC 40's low point, below 2,600 points.",
  "Pondérer les votes par le bilan des experts": "Weigh the votes by the experts' scorecard",
  "Pondérée par les poids : {0}.": "Weighted by the weights: {0}.",
  "Portail développeur Saxo": "Saxo developer portal",
  "Portefeuille": "Portfolio",
  "Portefeuille actualisé": "Portfolio refreshed",
  "Portefeuille complet": "Full portfolio",
  "Portefeuille fantôme": "Ghost portfolio",
  "Portefeuille indisponible : le courtier ne répond pas.": "Portfolio unavailable: the broker does not answer.",
  "Portefeuille réel": "Real portfolio",
  "Posez une question sur votre portefeuille…": "Ask a question about your portfolio…",
  "Positions": "Positions",
  "Positions clôturées et résultats réalisés.": "Closed positions and realised results.",
  "Positions courtes": "Short positions",
  "Positions du fantôme": "Ghost's positions",
  "Positives": "Positive",
  "Pour 8 chances sur 10 : versez": "For 8 chances out of 10: deposit",
  "Pour afficher votre portefeuille et suivre vos performances, connectez votre compte {0}.": "To show your portfolio and track your performance, connect your {0} account.",
  "Pour chaque ligne et valeur suivie, chaque expert annonce la probabilité qu’elle batte le CAC 40 sur {0} séances. Un expert bien calibré suit la diagonale : quand il annonce 70 %, la valeur bat l’indice 7 fois sur 10.": "For each line and tracked security, each expert states the probability that it beats the CAC 40 over {0} sessions. A well-calibrated expert follows the diagonal: when it says 70 %, the security beats the index 7 times out of 10.",
  "Pour le faire monter :": "To make it go up:",
  "Pour une valeur de la watchlist jugée très intéressante, ou une idée du panel.": "For a watchlist security judged very interesting, or a panel idea.",
  "Pourquoi cet ordre, maintenant ?": "Why this order, now?",
  "Pourquoi ça bouge ?": "Why is it moving?",
  "Premier expert actif": "First active expert",
  "Premier payeur : {0}": "Top payer: {0}",
  "Premier pays : {0}, {1} de vos placements.": "Top country: {0}, {1} of your investments.",
  "Premier secteur": "Top sector",
  "Premier seuil": "First threshold",
  "Première devise hors euro": "Top non-euro currency",
  "Première exposition réelle : {0}, {1} de vos placements, uniquement via vos ETF.": "Top real exposure: {0}, {1} of your investments, only through your ETFs.",
  "Première exposition réelle : {0}, {1} de vos placements.": "Top real exposure: {0}, {1} of your investments.",
  "Première hausse des taux de la BCE depuis 2011.": "The ECB's first rate rise since 2011.",
  "Prend la parole": "Takes the floor",
  "Principales lignes": "Main lines",
  "Principales lignes de l’indice {0} (fonds américain {1}, même indice) : {2} du fonds.": "Main lines of the {0} index (US fund {1}, same index): {2} of the fund.",
  "Principales lignes publiées : {0} du fonds.": "Main published lines: {0} of the fund.",
  "Prix : offert": "Price: bid",
  "Prix d'entrée": "Entry price",
  "Prix de revient total": "Total cost price",
  "Prix de sortie": "Exit price",
  "Prix d’entrée · de sortie": "Entry · exit price",
  "Prix d’exécution": "Execution price",
  "Prix plafond": "Price cap",
  "Prochain rappel le": "Next reminder on",
  "Prochaine tranche : {0}": "Next slice: {0}",
  "Prochaines publications": "Upcoming releases",
  "Procureur": "Prosecutor",
  "Procès introuvable.": "Trial not found.",
  "Profil PEA enregistré": "PEA profile saved",
  "Profil du PEA": "PEA profile",
  "Programme arrêté": "Programme stopped",
  "Programme créé : première tranche le {0}": "Programme created: first slice on {0}",
  "Programme en pause": "Programme paused",
  "Programme repris": "Programme resumed",
  "Programmer": "Schedule",
  "Programmes": "Programmes",
  "Programmes indisponibles.": "Programmes unavailable.",
  "Programmé": "Scheduled",
  "Projection, pas une promesse : les rendements sont tirés au hasard par blocs de douze mois consécutifs dans l’historique choisi. Tout le compte suit ce profil (liquidités comprises), sans frais ni impôts ; les versements s’arrêtent au plafond du PEA. Le passé ne garantit pas l’avenir.": "A projection, not a promise: returns are drawn at random in blocks of twelve consecutive months from the chosen history. The whole account follows this profile (cash included), without fees or taxes; deposits stop at the PEA ceiling. The past does not guarantee the future.",
  "Projet commun": "Joint draft",
  "Projet de rapport commun": "Draft joint report",
  "Projet du rapporteur — {0}": "Rapporteur's draft — {0}",
  "Proposer un achat quand un déclencheur est atteint": "Propose a purchase when a trigger is reached",
  "Proposition introuvable.": "Proposal not found.",
  "Proposition à confirmer : {0}": "Proposal to confirm: {0}",
  "Proposition écartée": "Proposal dismissed",
  "Propositions": "Proposals",
  "Propositions à examiner, ordres programmés (annulables jusqu’à leur envoi) et ordres passés.": "Proposals to review, scheduled orders (cancellable until they are sent) and past orders.",
  "Préférences enregistrées": "Preferences saved",
  "Prélèvements sociaux ({0})": "Social contributions ({0})",
  "Préparation de votre année…": "Preparing your year…",
  "Prépare son intervention": "Preparing their speech",
  "Présidente": "Presiding judge",
  "Pépite": "Pépite",
  "Pépite se cache : réessayez plus tard.": "Pépite is hiding: try again later.",
  "Pépite se réveille…": "Pépite is waking up…",
  "Périmètre": "Scope",
  "Périmètre de l’analyse": "Analysis scope",
  "Période": "Period",
  "Période du graphique": "Chart period",
  "Période graphique": "Chart period",
  "Qté": "Qty",
  "Qualité d’exécution": "Execution quality",
  "Quand le panel juge très intéressante une valeur de la watchlist que vous ne détenez pas.": "When the panel judges very interesting a watchlist security you do not hold.",
  "Quand le portefeuille varie fortement dans la journée (une alerte par sens et par jour).": "When the portfolio moves sharply during the day (one alert per direction per day).",
  "Quand l’agent ne choisit pas l’heure d’un ordre.": "When the agent does not choose an order's time.",
  "Quand un seuil de la watchlist fixé par le panel est atteint, préparer un achat à cours limité à confirmer dans la salle des ordres. Rien ne part sans vous.": "When a watchlist level set by the panel is reached, prepare a limit buy to confirm in the order room. Nothing is sent without you.",
  "Quand une de vos lignes varie fortement en séance, avec la raison trouvée dans l’actualité du jour (titres Google News lus par un modèle économique de votre fournisseur d’IA).": "When one of your lines moves sharply during the session, with the reason found in the day's news (Google News headlines read by a low-cost model of your AI provider).",
  "Quand une valeur de la watchlist atteint le niveau fixé par le rapport du jour (vérifié toutes les 15 minutes en séance).": "When a watchlist security reaches the level set by today's report (checked every 15 minutes during the session).",
  "Quantité": "Quantity",
  "Quantité : un nombre entier de titres.": "Quantity: a whole number of shares.",
  "Quantités en titres entiers. Les cours se saisissent avec une virgule ou un point.": "Quantities in whole shares. Prices can be entered with a comma or a point.",
  "Que devrais-je vendre ou alléger ?": "What should I sell or trim?",
  "Que voulez-vous recevoir ?": "What do you want to receive?",
  "Question posée": "Question asked",
  "Raccourci": "Shortcut",
  "Raccrocher": "Hang up",
  "Radar : {0} cible{1}, au centre les cours les plus proches de leur seuil": "Radar: {0} target{1}, in the centre the prices closest to their level",
  "Raison": "Reason",
  "Rappel le": "Reminder on",
  "Rappel programmé": "Reminder scheduled",
  "Rapport": "Report",
  "Rapport de l’analyse": "Analysis report",
  "Rapport du jour": "Today's report",
  "Rapport du {0}": "Report of {0}",
  "Rapport global": "Global report",
  "Rapport introuvable ou non accessible.": "Report not found or not accessible.",
  "Rapport quotidien": "Daily report",
  "Rapporteur": "Rapporteur",
  "Rapports d'experts": "Expert reports",
  "Rapports quotidiens": "Daily reports",
  "Ratio de Sharpe": "Sharpe ratio",
  "Rayonnant": "Radiant",
  "Rebond": "Rebound",
  "Recevez les notifications même lorsque l’application est fermée.": "Get notifications even when the app is closed.",
  "Recherche": "Search",
  "Recherche des données de marché et des actualités…": "Looking up market data and news…",
  "Recherche des rumeurs pour": "Looking for rumours for",
  "Recherche des rumeurs pour {0}…": "Looking for rumours for {0}…",
  "Recherche du débat du jour…": "Looking for today's debate…",
  "Recherche dégradée": "Degraded research",
  "Recherche d’actualités…": "Looking up news…",
  "Recherche en cours…": "Searching…",
  "Recherche et synthèse des sources": "Research and summary of the sources",
  "Recherche indisponible : saisissez le symbole exact (TICKER:place).": "Search unavailable: enter the exact symbol (TICKER:venue).",
  "Rechercher": "Search",
  "Rechercher ({0})": "Search ({0})",
  "Rechercher par valeur ou libellé…": "Search by security or label…",
  "Rechercher un instrument": "Search for an instrument",
  "Rechercher une action ou un ETF : ASML, TotalEnergies, LQQ…": "Search for a share or an ETF: ASML, TotalEnergies, LQQ…",
  "Rechercher une action ou un ETF européen": "Search for a European share or ETF",
  "Rechercher une actualité": "Search the news",
  "Rechercher une actualité…": "Search the news…",
  "Rechercher une opération": "Search for a trade",
  "Rechercher une page, une valeur ou une action": "Search for a page, a security or an action",
  "Rechercher une page, une valeur, une action…": "Search for a page, a security, an action…",
  "Rechercher une page, une valeur…": "Search for a page, a security…",
  "Rechercher une valeur": "Search for a security",
  "Rechercher une valeur à ajouter à la watchlist": "Search for a security to add to the watchlist",
  "Rechercher une valeur…": "Search for a security…",
  "Rechercher…": "Search…",
  "Recherche…": "Searching…",
  "Reconnectez-vous pour reprendre le trading.": "Log in again to resume trading.",
  "Reconnexion…": "Reconnecting…",
  "Refusé": "Refused",
  "Refusé par le code :": "Refused by the code:",
  "Regarder le débat ne déclenche aucune analyse.": "Watching the debate triggers no analysis.",
  "Rejouer": "Replay",
  "Relancer": "Restart",
  "Relecture": "Review",
  "Relecture indisponible": "Review unavailable",
  "Relecture — {0}": "Review — {0}",
  "Relectures": "Reviews",
  "Relire": "Read again",
  "Relire le dernier débat": "Read the latest debate again",
  "Rendement": "Return",
  "Rendement annualisé": "Annualised return",
  "Rendement brut supposé": "Assumed gross return",
  "Rendement cumulé": "Cumulative return",
  "Rendement cumulé depuis le premier rapport suivi. Votre compte est mesuré en rendement pondéré dans le temps : vos versements ne comptent pas.": "Cumulative return since the first report followed. Your account is measured as a time-weighted return: your deposits do not count.",
  "Rendement des lignes": "Lines' return",
  "Rendement pondéré dans le temps": "Time-weighted return",
  "Rendement pondéré dans le temps (les versements ne comptent pas) ; CAC 40 hors dividendes ; « tenu bon » : séances où le CAC 40 a perdu au moins 1,5 % sans vente de votre part dans les trois jours ; valeur star et lanterne rouge parmi les lignes détenues aujourd’hui ; décisions du panel notées à 20 séances.": "Time-weighted return (deposits do not count); CAC 40 excluding dividends; “held firm”: sessions where the CAC 40 lost at least 1.5 % with no sale on your part within three days; star and laggard among the lines held today; panel decisions scored at 20 sessions.",
  "Rendement pondéré dans le temps · CAC 40 hors dividendes · pas un conseil en investissement": "Time-weighted return · CAC 40 excluding dividends · not investment advice",
  "Rendement pondéré dans le temps, comparé aux indices": "Time-weighted return, compared with the indices",
  "Rendement total": "Total return",
  "Rendement, risque et statistiques de vos opérations.": "Return, risk and statistics of your trades.",
  "Rendements cumulés sur les séances du CAC 40. Le pilote est mesuré sur ses ordres exécutés, frais estimés déduits, en % du montant qu’il a engagé au plus haut.": "Cumulative returns over the CAC 40 sessions. The pilot is measured on its executed orders, estimated fees deducted, in % of the amount it committed at its peak.",
  "Rendements en % de l’enveloppe ; indice de prix, dividendes ignorés ; une nouvelle ligne pèse 3 %.": "Returns in % of the envelope; price index, dividends ignored; a new line weighs 3 %.",
  "Rendements tirés de": "Returns drawn from",
  "Rendez-vous le {0}.": "See you on {0}.",
  "Renforcer": "Reinforce",
  "Renforcer la ligne": "Reinforce the line",
  "Renouveler": "Renew",
  "Renouveler le lien": "Renew the link",
  "Renouveler le lien du calendrier ?": "Renew the calendar link?",
  "Renseignez la date d’ouverture de votre PEA pour voir son horizon fiscal.": "Enter your PEA's opening date to see its tax horizon.",
  "Renseignez la date d’ouverture et vos versements pour suivre le plafond et la date des 5 ans.": "Enter the opening date and your deposits to track the ceiling and the five-year date.",
  "Renseignez l’instrument, le total, les tranches, l’intervalle et l’écart.": "Fill in the instrument, the total, the slices, the interval and the gap.",
  "Renseignez vos versements dans Mon PEA pour tenir compte du plafond.": "Enter your deposits in My PEA to take the ceiling into account.",
  "Renseignez votre barème de courtage plus bas : sans lui, seuls les frais des ETF et les retenues à la source sont comptés.": "Enter your brokerage fee schedule below: without it, only ETF fees and withholding taxes are counted.",
  "Replier le menu": "Collapse the menu",
  "Reprendre": "Resume",
  "Reprendre le trading": "Resume trading",
  "Respirez": "Breathe",
  "Reste": "Left",
  "Reste en liquidités :": "Stays in cash:",
  "Rester en simulation": "Stay in simulation",
  "Retenu à l’étranger": "Withheld abroad",
  "Retenue": "Withholding",
  "Retenues à la source": "Withholding taxes",
  "Retenues à la source : taux usuels pour un résident français ; dans un PEA, elles ne sont ni imputables ni remboursables (remboursements conventionnels et régimes particuliers ignorés). Frais courants lus chez Yahoo Finance : vérifiez l’éligibilité au PEA et le DIC avant d’arbitrer, et n’oubliez pas qu’un arbitrage coûte deux ordres.": "Withholding taxes: usual rates for a French resident; in a PEA, they are neither deductible nor refundable (treaty refunds and special regimes ignored). Ongoing charges read on Yahoo Finance: check PEA eligibility and the KID before switching, and remember a switch costs two orders.",
  "Retire son chemisier au survol": "Takes off her blouse on hover",
  "Retirer": "Remove",
  "Retirer le contexte": "Remove the context",
  "Retirer {0}": "Remove {0}",
  "Retirer {0} de la watchlist": "Remove {0} from the watchlist",
  "Retour": "Back",
  "Retour au plus haut": "Back to the high",
  "Retour aux rapports": "Back to the reports",
  "Retour aux rapports d'experts": "Back to the expert reports",
  "Retour en simulation": "Back to simulation",
  "Retour à la connexion": "Back to login",
  "Retrouvez les analyses enregistrées, même si leur envoi par email a échoué.": "Find the saved analyses, even if their email delivery failed.",
  "Revenir au direct": "Back to live",
  "Revenus des douze prochains mois": "Income of the next twelve months",
  "Revenus futurs": "Future income",
  "Revenus par ligne": "Income per line",
  "Rien ne part sans vous : « Passer ces ordres » ouvre un panier vérifié par les garde-fous du trading (ventes d’abord, achats ensuite). Actions entières, frais non inclus. Dans le PEA, une vente n’est pas imposée tant que rien n’est retiré du plan.": "Nothing is sent without you: “Place these orders” opens a basket checked by the trading guard rails (sales first, purchases next). Whole shares, fees not included. In the PEA, a sale is not taxed as long as nothing is withdrawn from the plan.",
  "Rien ne part sans vérification : éligibilité PEA, liquidités, vos limites, puis le contrôle préalable de Saxo.": "Nothing is sent without checks: PEA eligibility, cash, your limits, then Saxo's precheck.",
  "Rien n’est envoyé : le ticket s’ouvre pré-rempli, vérifié par les garde-fous, et c’est vous qui l’envoyez.": "Nothing is sent: the ticket opens pre-filled, checked by the guard rails, and you are the one who sends it.",
  "Rien à acheter : aucune ligne n’est assez loin de sa cible pour un ordre au-dessus du minimum.": "Nothing to buy: no line is far enough from its target for an order above the minimum.",
  "Rien à décomposer pour l’instant": "Nothing to break down for now",
  "Rien à raconter pour {0}": "Nothing to tell for {0}",
  "Rien à rejouer": "Nothing to replay",
  "Risque et rendement sur la période sélectionnée": "Risk and return over the selected period",
  "Royaume-Uni": "United Kingdom",
  "Rumeurs": "Rumours",
  "Rumeurs de marché": "Market rumours",
  "Règles : départ à 100 en liquidités ; à chaque rapport, à la clôture de la veille, chaque ligne prend le poids cible du panel (médiane des experts qui soutiennent la décision) ; « Solder » vend tout ; sans poids cible, « Renforcer » augmente la ligne d’un quart et « Alléger » la divise par deux ; un intérêt fort en watchlist ouvre une ligne de 3 % ; la réserve de liquidités du panel est respectée, sans jamais emprunter. Un écart de moins d’un demi-point n’est pas corrigé. Chaque ordre paie votre barème de courtage (page Frais & fiscalité), ramené à la taille de votre compte au départ du fantôme. Dividendes ignorés (indice de prix), alors que votre compte réel les touche.": "Rules: start at 100 in cash; at each report, at the previous day's close, each line takes the panel's target weight (median of the experts backing the decision); “Close out” sells everything; without a target weight, “Reinforce” raises the line by a quarter and “Trim” halves it; a strong interest on the watchlist opens a 3 % line; the panel's cash reserve is respected, without ever borrowing. A gap of less than half a point is not corrected. Each order pays your brokerage fee schedule (Fees & tax page), scaled to your account's size when the ghost started. Dividends ignored (price index), while your real account receives them.",
  "Règles : « Renforcer » et un intérêt fort sont justes si la valeur bat le CAC 40 ; « Alléger », « Solder », un intérêt faible ou nul, si elle fait moins bien ; « Conserver », si elle ne décroche pas de plus de 3 points. L’intérêt moyen n’est pas noté. Indice de prix, hors dividendes.": "Rules: “Reinforce” and a strong interest are right if the security beats the CAC 40; “Trim”, “Close out”, a low or no interest, if it does worse; “Hold”, if it does not fall behind by more than 3 points. Medium interest is not scored. Price index, excluding dividends.",
  "Ré-inclure {0} dans l'analyse": "Include {0} in the analysis again",
  "Réactiver le micro": "Unmute the microphone",
  "Réalisée": "Realised",
  "Récapitulatif": "Summary",
  "Rédigé par l’IA à partir de vos positions": "Written by the AI from your positions",
  "Réduire": "Collapse",
  "Réduire le rapport": "Collapse the report",
  "Réel": "Real",
  "Réel seulement": "Real only",
  "Réessayer": "Try again",
  "Réessayer le chargement de l'historique": "Retry loading the history",
  "Réessayer le chargement du rapport": "Retry loading the report",
  "Réfléchit": "Thinking",
  "Réglages": "Settings",
  "Réglages du pilote": "Pilot settings",
  "Réglages enregistrés": "Settings saved",
  "Réglages enregistrés.": "Settings saved.",
  "Réglages trading": "Trading settings",
  "Régénérer la synthèse": "Regenerate the summary",
  "Réinitialisation SIM": "SIM reset",
  "Réinitialisation de la simulation impossible.": "Unable to reset the simulation.",
  "Réinitialisation programmée le {0} (marché fermé).": "Reset scheduled on {0} (market closed).",
  "Réinitialisation programmée à l’ouverture": "Reset scheduled at the opening",
  "Réinitialiser": "Reset",
  "Réinitialiser la simulation": "Reset the simulation",
  "Réinitialiser la simulation ?": "Reset the simulation?",
  "Réinitialiser le mot de passe": "Reset the password",
  "Réinitialisez la simulation pour mesurer le pilote à partir d’une copie exacte de votre portefeuille réel.": "Reset the simulation to measure the pilot from an exact copy of your real portfolio.",
  "Répartition": "Breakdown",
  "Répartition mensuelle": "Monthly breakdown",
  "Répartition sectorielle": "Sector breakdown",
  "Réserve de liquidités": "Cash reserve",
  "Réserve de liquidités (%)": "Cash reserve (%)",
  "Réserves": "Reservations",
  "Résultat": "Result",
  "Résultat %": "Result %",
  "Résultat (%)": "Result (%)",
  "Résultat du jour": "Day's result",
  "Résultat du pilote": "Pilot's result",
  "Résultat réalisé": "Realised result",
  "Résultat €": "Result €",
  "Résultats": "Results",
  "Résultats de recherche": "Search results",
  "Résultats des entreprises": "Company results",
  "Résultats du": "Results of",
  "Rééquilibrage": "Rebalancing",
  "Rééquilibrage vers vos poids cibles.": "Rebalancing towards your target weights.",
  "SIM": "SIM",
  "SIM seulement": "SIM only",
  "Sa clé API sera effacée.": "Its API key will be erased.",
  "Sa composition aujourd’hui.": "Its composition today.",
  "Saisissez des nombres (0 = sans limite).": "Enter numbers (0 = no limit).",
  "Saisissez des nombres (0 si aucun frais).": "Enter numbers (0 if no fees).",
  "Saisissez des nombres dans chaque champ.": "Enter numbers in each field.",
  "Saisissez la clé API de cet expert": "Enter this expert's API key",
  "Saisissez la clé et le secret, puis connectez-vous : tout commence en SIM.": "Enter the key and the secret, then log in: everything starts in SIM.",
  "Saisissez un poids cible par ligne, ou partez de l’allocation actuelle.": "Enter a target weight per line, or start from the current allocation.",
  "Saisissez votre adresse email pour recevoir un lien de réinitialisation.": "Enter your email address to receive a reset link.",
  "Saisissez votre clé API": "Enter your API key",
  "Salle de marché": "Trading room",
  "Salle de marché indisponible.": "Trading room unavailable.",
  "Salle des ordres": "Order room",
  "Sans barème de frais saisi (page Frais & fiscalité), la simulation ne paie aucun frais.": "Without a fee schedule entered (Fees & tax page), the simulation pays no fees.",
  "Sans cours": "No price",
  "Sans cours aujourd’hui :": "No price today:",
  "Sans frais pour l’instant : renseignez votre barème dans": "No fees for now: enter your fee schedule in",
  "Sans historique de cours, le fantôme n’a pas pu acheter :": "Without a price history, the ghost could not buy:",
  "Sans rien faire": "Doing nothing",
  "Santé": "Health",
  "Saxo ne répond pas.": "Saxo does not answer.",
  "Saxo ouvre le compte de simulation avec un million d’euros fictifs et aucune ligne. Réinitialisez-le depuis votre portefeuille réel : mêmes lignes, achetées au marché, et la valeur exacte de votre PEA.": "Saxo opens the simulation account with a million fictitious euros and no line. Reset it from your real portfolio: same lines, bought at market, and your PEA's exact value.",
  "Score de Brier : moyenne de (probabilité − résultat)², le résultat valant 1 si la valeur a battu le CAC 40, depuis la clôture précédant le rapport. 0 est parfait, 0,25 revient à répondre 50 % à tout. Seules les analyses indépendantes comptent, avant la table ronde.": "Brier score: mean of (probability − outcome)², the outcome being 1 if the security beat the CAC 40, from the close before the report. 0 is perfect, 0.25 is answering 50 % to everything. Only the independent analyses count, before the round table.",
  "Se connecter": "Log in",
  "Se connecter à Saxo": "Connect to Saxo",
  "Se déconnecter": "Log out",
  "Second ordre": "Second order",
  "Secret (App Secret)": "Secret (App Secret)",
  "Secteurs": "Sectors",
  "Sections des réglages": "Settings sections",
  "Sens": "Side",
  "Sens de l’ordre": "Order side",
  "Sens du programme": "Programme side",
  "Sensibilité": "Sensitivity",
  "Serveur injoignable": "Server unreachable",
  "Serveur injoignable — nouvelle tentative automatique toutes les 10 secondes.": "Server unreachable — automatic retry every 10 seconds.",
  "Services aux collectivités": "Utilities",
  "Ses derniers mouvements, au poids près.": "Its latest moves, to the weight.",
  "Ses quatre besoins": "Its four needs",
  "Session de trading expirée": "Trading session expired",
  "Session de trading non connectée : enregistrez et connectez votre application Saxo.": "Trading session not connected: save and connect your Saxo application.",
  "Session de trading non connectée : les tranches attendront la reconnexion.": "Trading session not connected: the slices will wait for the reconnection.",
  "Session expirée": "Session expired",
  "Session fermée": "Session closed",
  "Seuil": "Threshold",
  "Seuil de conviction": "Conviction threshold",
  "Seuil de déclenchement": "Trigger level",
  "Seuil d’alerte": "Alert threshold",
  "Seuil {0} · dernier {1} · à {2}": "Level {0} · last {1} · at {2}",
  "Seuil « Pourquoi ça bouge ? »": "“Why is it moving?” threshold",
  "Seuils du panel indisponibles.": "Panel levels unavailable.",
  "Seulement les décisions prises par tout le panel.": "Only the decisions taken by the whole panel.",
  "Si un compte existe pour": "If an account exists for",
  "Si vous aviez tout suivi": "If you had followed everything",
  "Signaux AMF": "AMF signals",
  "Signaux faibles et bruits de marché sur vos valeurs, à recouper avant toute décision.": "Weak signals and market noise on your securities, to cross-check before any decision.",
  "Signaux faibles et bruits de marché, à recouper avant toute décision": "Weak signals and market noise, to cross-check before any decision",
  "Simulateur de crise": "Crisis simulator",
  "Simulateur indisponible.": "Simulator unavailable.",
  "Simulation": "Simulation",
  "Simulation (SIM)": "Simulation (SIM)",
  "Simulation : vos lignes d’aujourd’hui rejouées sur les cours de l’époque, ou sur le CAC 40 multiplié par leur bêta de l’année écoulée quand elles n’étaient pas cotées. Dividendes, frais et fiscalité ignorés ; rien n’est passé en bourse. Une vente alors que le portefeuille perd 10 % ou plus compte comme une vente de panique.": "Simulation: today's lines replayed on the prices of the time, or on the CAC 40 multiplied by their beta of the past year when they were not listed. Dividends, fees and taxes ignored; nothing is traded. A sale while the portfolio is down 10 % or more counts as a panic sale.",
  "Simulation indisponible.": "Simulation unavailable.",
  "Simulation réinitialisée : {0} achat{1} au marché": "Simulation reset: {0} purchase{1} at market",
  "Simulation sur le passé": "Simulation on the past",
  "Simuler": "Simulate",
  "Simuler un retrait": "Simulate a withdrawal",
  "Sniper": "Sniper",
  "Sniper : {0} (rapport du {1}).": "Sniper: {0} (report of {1}).",
  "Solder": "Close out",
  "Solder la ligne": "Close out the line",
  "Soldée le": "Closed out on",
  "Somme des ordres envoyés dans la journée.": "Sum of the orders sent during the day.",
  "Son arbre d’évolution": "Its evolution tree",
  "Sortie": "Exit",
  "Standard & Poor's retire le AAA des États-Unis.": "Standard & Poor's strips the United States of its AAA.",
  "Statut": "Status",
  "Stop de protection": "Protective stop",
  "Stop limite": "Stop limit",
  "Stop suiveur": "Trailing stop",
  "Style cartoon d’après photo : manteau et sweat à capuche": "Cartoon style from a photo: coat and hoodie",
  "Suggère des ETF éligibles PEA à ajouter": "Suggest PEA-eligible ETFs to add",
  "Suisse": "Switzerland",
  "Suite dans le rapport complet.": "Continued in the full report.",
  "Suivez et analysez votre PEA dès aujourd’hui.": "Track and analyse your PEA from today.",
  "Suivez les experts pendant la génération du rapport quotidien, ou d'un débat lancé à la demande sur une valeur : analyses, table ronde et conclusion, au fil de l'écriture.": "Follow the experts while the daily report is generated, or a debate started on demand on a security: analyses, round table and conclusion, as they are written.",
  "Suivez votre PEA, comprenez chaque mouvement et décidez avec l’appui d’analyses indépendantes.": "Track your PEA, understand every move and decide with the support of independent analyses.",
  "Suivre le débat en direct": "Follow the debate live",
  "Supprimer": "Delete",
  "Supprimer l’expert « Macro » ?": "Delete the “Macro” expert?",
  "Supprimer l’expert « {0} » ?": "Delete the “{0}” expert?",
  "Supprimer {0}": "Delete {0}",
  "Supprimer « {0} »": "Delete “{0}”",
  "Sur 20 ans, avec un rendement brut de": "Over 20 years, with a gross return of",
  "Sur PRU": "On avg. cost",
  "Sur iPhone et iPad, ajoutez d’abord PEA Wallet à l’écran d’accueil (Partager, puis « Sur l’écran d’accueil »), ouvrez l’application depuis son icône et revenez ici.": "On iPhone and iPad, first add PEA Wallet to the home screen (Share, then “Add to Home Screen”), open the app from its icon and come back here.",
  "Sur les douze derniers mois : {0} ordre{1} visible{2} chez le courtier.": "Over the last twelve months: {0} order{1} visible at the broker.",
  "Suède": "Sweden",
  "Symbole": "Symbol",
  "Symboles séparés par des virgules (TTE, SAN:xpar…).": "Symbols separated by commas (TTE, SAN:xpar…).",
  "Synthèse de {0} — {1}": "Summary of {0} — {1}",
  "Synthèse des positions": "Positions summary",
  "Synthèse du jour": "Today's summary",
  "Séance {0} sur {1}": "Session {0} of {1}",
  "Sélection de valeurs": "Selection of securities",
  "Sélectionnez un rapport dans l'historique pour le consulter.": "Select a report in the history to view it.",
  "Sûr de lui à tort": "Confidently wrong",
  "Tab": "Tab",
  "Table ronde": "Round table",
  "Table ronde des experts": "Experts' round table",
  "Table ronde et consolidation": "Round table and consolidation",
  "Tableau": "Table",
  "Tableau de bord": "Dashboard",
  "Tant que le panel est incomplet, le rapport quotidien actuel continue d'être généré et envoyé.": "As long as the panel is incomplete, the current daily report keeps being generated and sent.",
  "Tapez « TRADING RÉEL » pour confirmer": "Type “TRADING RÉEL” to confirm",
  "Tapez « {0} » pour confirmer": "Type “{0}” to confirm",
  "Taux de décisions justes selon leur nature.": "Rate of right decisions by kind.",
  "Taux de réussite": "Hit rate",
  "Taux d’exécution": "Fill rate",
  "Taux longs (10 ans américain)": "Long rates (US 10-year)",
  "Taïwan": "Taiwan",
  "Technologie": "Technology",
  "Tendances et contexte de marché": "Trends and market context",
  "Terminé": "Finished",
  "Terminé le (heure de Paris)": "Finished on (Paris time)",
  "Texte dense pour les tableaux et listes — 13,5 px.": "Dense text for tables and lists — 13.5 px.",
  "Ticket": "Ticket",
  "Ticket d’ordre": "Order ticket",
  "Ticket pré-rempli pour {0} : vérifiez-le avant l’envoi": "Ticket pre-filled for {0}: check it before sending",
  "Titre de carte — Évolution du portefeuille": "Card title — Portfolio evolution",
  "Titres": "Shares",
  "Titres détenus": "Shares held",
  "Titres récents concernant cette valeur": "Recent headlines about this security",
  "Titres surveillés": "Watched securities",
  "Toast erreur": "Error toast",
  "Toast info": "Info toast",
  "Toast succès": "Success toast",
  "Total": "Total",
  "Total attendu": "Expected total",
  "Total exprimé en": "Total expressed in",
  "Total versé depuis l’ouverture, hors plus-values et dividendes réinvestis.": "Total deposited since the opening, excluding gains and reinvested dividends.",
  "Total {0}": "Total {0}",
  "Tour": "Round",
  "Tours de table ronde (max)": "Round-table rounds (max)",
  "Tours de table ronde (max.)": "Round-table rounds (max.)",
  "Tous": "All",
  "Tous les ordres, ceux de Gladys et du pilote compris, partent dans cet environnement.": "Every order, Gladys' and the pilot's included, goes to this environment.",
  "Tous les … jours de bourse": "Every … trading days",
  "Tout": "All",
  "Tout actualiser": "Refresh everything",
  "Tout arrêter": "Stop everything",
  "Tout le journal": "The whole journal",
  "Tout le portefeuille ou quelques lignes": "The whole portfolio or a few lines",
  "Tout régénérer": "Regenerate everything",
  "Tout réinvestir": "Reinvest everything",
  "Tout vendre": "Sell everything",
  "Tout voir": "See all",
  "Toute décision majoritaire ; jamais une décision par défaut.": "Any majority decision; never a default decision.",
  "Toutes": "All",
  "Toutes les décisions": "All decisions",
  "Tracé de la constellation…": "Drawing the constellation…",
  "Trading": "Trading",
  "Trading en pause": "Trading paused",
  "Trading en pause : aucun ordre ne part": "Trading paused: no order is sent",
  "Trading en pause : le pilote ne prépare ni n’envoie rien tant que vous n’avez pas repris la main.": "Trading paused: the pilot neither prepares nor sends anything until you take back control.",
  "Trading en pause, {0} ordre{1} annulé{2}": "Trading paused, {0} order{1} cancelled",
  "Trading indisponible.": "Trading unavailable.",
  "Trading réactivé": "Trading resumed",
  "Trading réel activé": "Real trading enabled",
  "Trajectoire médiane :": "Median path:",
  "Trajectoires": "Paths",
  "Tranches envoyées : {0} sur {1}": "Slices sent: {0} of {1}",
  "Traverser cette crise": "Go through this crisis",
  "Triées par valorisation": "Sorted by value",
  "Trop de tentatives : réessayez dans 15 minutes.": "Too many attempts: try again in 15 minutes.",
  "Type": "Type",
  "Type de compte": "Account type",
  "Type de graphique": "Chart type",
  "Type de rapport": "Report type",
  "Type des ordres": "Order type",
  "Type d’actif": "Asset type",
  "Type d’analyse": "Analysis type",
  "Type d’application : « Code » (Authorization Code Grant), avec le droit de trading coché. L’accès en lecture seule actuel reste séparé et inchangé.": "Application type: “Code” (Authorization Code Grant), with the trading right ticked. The current read-only access stays separate and unchanged.",
  "Type d’ordre": "Order type",
  "Typographie": "Typography",
  "Télécharger l’image": "Download the image",
  "Un briefing deux jours avant la publication des résultats d’une de vos lignes, puis l’analyse le soir même.": "A briefing two days before one of your lines publishes its results, then the analysis the same evening.",
  "Un briefing unique à partir des rumeurs de chaque valeur.": "A single briefing from each security's rumours.",
  "Un krach du passé rejoué séance par séance sur votre portefeuille d’aujourd’hui. Vendre, renforcer ou attendre : à la fin, on compare avec « ne rien faire ».": "A past crash replayed session by session on today's portfolio. Sell, reinforce or wait: at the end, it is compared with “doing nothing”.",
  "Un loyer est payé": "A rent is paid",
  "Un ordre au marché s’exécute aussitôt, au meilleur prix disponible. Les garde-fous sont revérifiés avant la modification.": "A market order executes at once, at the best available price. The guard rails are checked again before the change.",
  "Un ordre en carnet est retiré chez Saxo ; un ordre programmé ou à confirmer ne partira pas.": "An order in the book is withdrawn at Saxo; a scheduled order or one to confirm will not be sent.",
  "Un ordre par seconde (limite de Saxo) : patientez quelques secondes par ligne.": "One order per second (Saxo's limit): wait a few seconds per line.",
  "Un portefeuille virtuel qui suit à la lettre chaque décision du panel d’experts, comparé à votre compte réel.": "A virtual portfolio that follows each decision of the expert panel to the letter, compared with your real account.",
  "Un procès pour rire et pour réfléchir : aucun ordre n’a été passé, vous restez seul juge.": "A trial for fun and for thought: no order was placed, you remain the only judge.",
  "Un rappel arrivera le jour du versement.": "A reminder will arrive on deposit day.",
  "Un rapport chaque matin, débattu par un panel d’experts IA": "A report every morning, debated by a panel of AI experts",
  "Un rapport est déjà en cours de génération : suivez-le dans « Débat en direct » ou réessayez dans quelques minutes.": "A report is already being generated: follow it in “Live debate” or try again in a few minutes.",
  "Un retrait avant cette date clôture le plan : vous perdez son antériorité et le gain est imposé à {0} % en plus des {1} % de prélèvements sociaux.": "A withdrawal before this date closes the plan: you lose its seniority and the gain is taxed at {0} % on top of the {1} % social contributions.",
  "Un week-end, le rappel arrive le lundi suivant.": "On a weekend, the reminder arrives the following Monday.",
  "Unanimité": "Unanimity",
  "Unanimité ou au moins deux tiers du panel (pondérés si les votes le sont).": "Unanimity or at least two thirds of the panel (weighted if the votes are).",
  "Une décision prise à chaud se regrette souvent. Programmez un rappel : demain, vous déciderez avec un jour de recul.": "A decision taken in the heat of the moment is often regretted. Schedule a reminder: tomorrow, you will decide with a day's distance.",
  "Une image au format portrait (1080 × 1350), sans montants par défaut.": "A portrait image (1080 × 1350), without amounts by default.",
  "Une ligne de votre portefeuille au banc des accusés : l’expert le plus sceptique du panel requiert, le plus convaincu plaide, vous êtes le jury et Gladys préside.": "A line of your portfolio in the dock: the panel's most sceptical expert prosecutes, the most convinced pleads, you are the jury and Gladys presides.",
  "Une position courte est un pari de fonds sur une baisse, pas une information sur l’entreprise. Les attributions d’actions gratuites et les nantissements ne sont pas des achats sur le marché.": "A short position is a fund's bet on a fall, not information about the company. Free share awards and pledges are not market purchases.",
  "Une réponse détaillée sur votre portefeuille peut prendre jusqu’à une minute.": "A detailed answer about your portfolio can take up to a minute.",
  "Une tranche à cours limité (milieu de fourchette ± l’écart) tous les N jours de bourse, à l’heure choisie. Chaque tranche passe les garde-fous ; une tranche refusée est reportée au lendemain.": "A limit slice (mid of the spread ± the gap) every N trading days, at the chosen time. Each slice goes through the guard rails; a refused slice is postponed to the next day.",
  "Une voix par expert": "One vote per expert",
  "Unité du total": "Total's unit",
  "Utiliser le symbole {0}": "Use the symbol {0}",
  "Utilisez « Installer l’application » dans le menu du navigateur, ou « Sur l’écran d’accueil » dans le menu Partager de Safari.": "Use “Install app” in the browser menu, or “Add to Home Screen” in Safari's Share menu.",
  "Utilisé par le pilote : 0 = jamais.": "Used by the pilot: 0 = never.",
  "V5 avec le sweat ouvert jusqu’à la taille": "V5 with the hoodie open to the waist",
  "Valable pour tous vos appareils abonnés.": "Valid for all your subscribed devices.",
  "Valeur": "Security",
  "Valeur / indice": "Security / index",
  "Valeur actuelle": "Current value",
  "Valeur actuelle moins versements cumulés.": "Current value minus cumulative deposits.",
  "Valeur de départ (votre PEA)": "Starting value (your PEA)",
  "Valeur du compte": "Account value",
  "Valeur du compte : {0}": "Account value: {0}",
  "Valeur du compte indisponible (courtier non connecté) : la projection part de": "Account value unavailable (broker not connected): the projection starts from",
  "Valeur du compte ou historique indisponible : le nuage ne peut pas se former.": "Account value or history unavailable: the cloud cannot form.",
  "Valeur estimée": "Estimated value",
  "Valeur hors portefeuille": "Security outside the portfolio",
  "Valeur restante du plan": "Plan's remaining value",
  "Valeur star": "Star security",
  "Valeur totale": "Total value",
  "Valeur totale du portefeuille": "Portfolio's total value",
  "Valeurs suivies": "Tracked securities",
  "Valeurs à analyser": "Securities to analyse",
  "Validité": "Validity",
  "Valorisation": "Value",
  "Valorisation indisponible : connectez votre courtier.": "Value unavailable: connect your broker.",
  "Valorisation totale, liquidités comprises": "Total value, cash included",
  "Variation de valeur": "Change in value",
  "Variation du jour indisponible.": "Day's change unavailable.",
  "Variation du portefeuille depuis la clôture de la veille.": "Portfolio change since the previous close.",
  "Variation d’une ligne depuis la clôture de la veille.": "A line's change since the previous close.",
  "Variation et résultat du jour de chaque ligne du compte de trading.": "Day's change and result of each line of the trading account.",
  "Variations du jour : {0}": "Day's changes: {0}",
  "Vendre": "Sell",
  "Vendre met la ligne en liquidités au cours du jour ; renforcer achète pour 5 % de la valeur de départ, si les liquidités le permettent.": "Selling turns the line into cash at the day's price; reinforcing buys 5 % of the starting value, if the cash allows.",
  "Vendre {0}": "Sell {0}",
  "Vendre à l’intérieur du PEA sans retirer ne coûte pas d’impôt : la vraie question est de savoir si vos raisons d’investir ont changé.": "Selling inside the PEA without withdrawing costs no tax: the real question is whether your reasons for investing have changed.",
  "Vendu à": "Sold at",
  "Vente": "Sale",
  "Vente {0} au marché": "Sell {0} at market",
  "Vente {0} au marché {1}": "Sell {0} at market {1}",
  "Vente {0} stop limite": "Sell {0} stop limit",
  "Vente {0} stop limite {1}": "Sell {0} stop limit {1}",
  "Vente {0} stop suiveur": "Sell {0} trailing stop",
  "Vente {0} stop suiveur {1}": "Sell {0} trailing stop {1}",
  "Vente {0} à cours limité": "Sell {0} limit",
  "Vente {0} à cours limité {1}": "Sell {0} limit {1}",
  "Vente {0} à seuil de déclenchement": "Sell {0} stop",
  "Vente {0} à seuil de déclenchement {1}": "Sell {0} stop {1}",
  "Ventes": "Sales",
  "Ventes à perte d’affilée": "Losing sales in a row",
  "Verdict": "Verdict",
  "Verdict rendu": "Verdict delivered",
  "Vers {0}.": "Towards {0}.",
  "Versement": "Deposit",
  "Versement mensuel": "Monthly deposit",
  "Versement mensuel enregistré": "Monthly deposit saved",
  "Versement mensuel investi en dividendes": "Monthly deposit invested in dividends",
  "Versement mensuel réparti vers les lignes sous leur cible.": "Monthly deposit spread over the lines below their target.",
  "Versements": "Deposits",
  "Versements cumulés": "Cumulative deposits",
  "Versements reçus et détachements programmés sur vos positions.": "Payments received and scheduled ex-dates on your positions.",
  "Version finale": "Final version",
  "Versés": "Deposited",
  "Vider le cache": "Clear the cache",
  "Vitesse": "Speed",
  "Voici les ordres que suggère mon assistant de rééquilibrage : {0} Liquidités après opérations : {1}. Qu'en penses-tu ? Y a-t-il un ordre à éviter ou à étaler ?": "Here are the orders my rebalancing assistant suggests: {0} Cash after the trades: {1}. What do you think? Is there an order to avoid or to stagger?",
  "Voilé": "Hazy",
  "Voir Pépite": "See Pépite",
  "Voir l'archive de ce débat": "See this debate's archive",
  "Voir le débat": "See the debate",
  "Voir le journal": "See the journal",
  "Voir les": "See the",
  "Voir les 9 positions": "See the 9 positions",
  "Voir les rapports plus anciens": "See older reports",
  "Voix de synthèse du serveur (OpenAI)": "Server synthetic voice (OpenAI)",
  "Volatilité": "Volatility",
  "Vos ETF ouverts": "Your ETFs opened up",
  "Vos ETF ouverts : ce que vous détenez vraiment, entreprise par entreprise, par pays, devise et secteur.": "Your ETFs opened up: what you really hold, company by company, by country, currency and sector.",
  "Vos analyses précédentes, de la plus récente à la plus ancienne": "Your previous analyses, from the most recent to the oldest",
  "Vos choix battent l’indice.": "Your choices beat the index.",
  "Vos courses du mois sont payées": "Your month's groceries are paid",
  "Vos décisions ont coûté {0} points par rapport à ne rien faire.": "Your decisions cost {0} points compared with doing nothing.",
  "Vos décisions ont rapporté {0} points par rapport à ne rien faire.": "Your decisions earned {0} points compared with doing nothing.",
  "Vos identifiants Saxo de trading, l’environnement actif et vos limites de risque.": "Your Saxo trading credentials, the active environment and your risk limits.",
  "Vos lignes": "Your lines",
  "Vos lignes comme des étoiles : la taille donne le poids, la couleur le secteur, les traits relient les valeurs qui bougent ensemble.": "Your lines as stars: size gives the weight, colour the sector, the lines link the securities that move together.",
  "Vos lignes, leur poids dans le PEA et les valeurs que vous surveillez.": "Your lines, their weight in the PEA and the securities you watch.",
  "Vos opérations soldées apparaîtront ici.": "Your closed trades will appear here.",
  "Vos ordres en cours, les derniers exécutés et l’état du compte de trading. Chaque ordre passe par les garde-fous du PEA avant de partir.": "Your open orders, the latest executed and the trading account's state. Each order goes through the PEA guard rails before leaving.",
  "Vos premières expositions réelles, en direct et à travers vos ETF, en % de vos placements.": "Your top real exposures, directly and through your ETFs, in % of your investments.",
  "Vos ventes ont eu du flair.": "Your sales had flair.",
  "Vote impossible.": "Vote failed.",
  "Votre PEA": "Your PEA",
  "Votre PEA a fait": "Your PEA made",
  "Votre PEA a passé ses cinq ans le {0} : un retrait ne le clôture plus.": "Your PEA turned five on {0}: a withdrawal no longer closes it.",
  "Votre PEA a une petite créature : elle grandit avec le plan et sa santé dépend de vos habitudes d’investisseur.": "Your PEA has a little creature: it grows with the plan and its health depends on your investor habits.",
  "Votre PEA aura cinq ans le {0}": "Your PEA will be five on {0}",
  "Votre PEA aura cinq ans le {0}{1}.": "Your PEA will be five on {0}{1}.",
  "Votre PEA suivi en temps réel, ligne par ligne": "Your PEA tracked in real time, line by line",
  "Votre abonnement de streaming est payé": "Your streaming subscription is paid",
  "Votre année en PEA": "Your year in the PEA",
  "Votre assistante patrimoniale": "Your wealth assistant",
  "Votre barème": "Your fee schedule",
  "Votre café du matin est payé": "Your morning coffee is paid",
  "Votre compte": "Your account",
  "Votre compte aujourd’hui": "Your account today",
  "Votre compte ne recule pas aujourd’hui. Si l’envie de vendre vient d’ailleurs, prenez le temps de la nommer avant d’agir.": "Your account is not falling today. If the urge to sell comes from elsewhere, take the time to name it before acting.",
  "Votre compte recule aujourd’hui. Une séance ne dit rien de la valeur de vos entreprises sur cinq ans.": "Your account is falling today. One session says nothing about the value of your companies over five years.",
  "Votre compte recule de {0} points de plus que le CAC 40 : regardez quelles lignes pèsent, sans décider à chaud.": "Your account is falling {0} points more than the CAC 40: look at which lines weigh, without deciding in the heat of the moment.",
  "Votre compte résiste mieux que le CAC 40 aujourd’hui.": "Your account is holding up better than the CAC 40 today.",
  "Votre compte suit le marché : ce n’est pas une mauvaise nouvelle propre à vos lignes, c’est une journée de baisse générale.": "Your account is following the market: it is not bad news specific to your lines, it is a day of general decline.",
  "Votre compte, la connexion au courtier, l’intelligence artificielle, l’assistante Gladys et les notifications.": "Your account, the broker connection, artificial intelligence, the Gladys assistant and notifications.",
  "Votre courtier ne transmet ni la date d’ouverture ni le total réellement versé.": "Your broker passes on neither the opening date nor the total actually deposited.",
  "Votre exposition réelle {0} est de {1}, liquidités comprises.": "Your real exposure {0} is {1}, cash included.",
  "Votre forfait et votre box sont payés": "Your phone and internet plans are paid",
  "Votre meilleure heure : {0} (glissement le plus faible, au moins trois ordres).": "Your best hour: {0} (lowest slippage, at least three orders).",
  "Votre objectif": "Your goal",
  "Votre patrimoine,": "Your wealth,",
  "Votre patrimoine, en toute clarté": "Your wealth, in full clarity",
  "Votre plan": "Your plan",
  "Votre portefeuille": "Your portfolio",
  "Votre portefeuille est": "Your portfolio is",
  "Votre portefeuille et l’historique de vos opérations sont joints automatiquement à chaque question.": "Your portfolio and your trade history are attached automatically to each question.",
  "Votre portefeuille ne contient pas encore de ligne.": "Your portfolio does not hold any line yet.",
  "Votre première audience s’affichera ici.": "Your first hearing will appear here.",
  "Votre question": "Your question",
  "Votre rapport du jour": "Your report of the day",
  "Votre rendement pondéré dans le temps face à un ETF MSCI World sur la même période.": "Your time-weighted return against an MSCI World ETF over the same period.",
  "Votre versement réparti vers les lignes les plus en dessous de leur cible enregistrée, en actions entières, sans toucher à la réserve de liquidités ni dépasser le plafond du PEA.": "Your deposit spread over the lines furthest below their saved target, in whole shares, without touching the cash reserve or going over the PEA ceiling.",
  "Votre vrai compte. L’application doit être validée par Saxo pour le réel et autorisée au trading.": "Your real account. The application must be approved by Saxo for real money and allowed to trade.",
  "Votre watchlist est vide. Ajoutez des actions ou des ETF pour suivre leurs rumeurs.": "Your watchlist is empty. Add shares or ETFs to follow their rumours.",
  "Votre watchlist est vide. Ajoutez des valeurs pour voir leurs rumeurs.": "Your watchlist is empty. Add securities to see their rumours.",
  "Votre watchlist est vide. Recherchez une action ou un ETF pour commencer à le surveiller.": "Your watchlist is empty. Search for a share or an ETF to start watching it.",
  "Vous": "You",
  "Vous :": "You:",
  "Vous avez déjà choisi d’attendre {0} fois.": "You have already chosen to wait {0} times.",
  "Vous avez tenu bon": "You held firm",
  "Vous avez vendu alors que le portefeuille perdait 10 % ou plus : c’est le réflexe qui coûte le plus dans un PEA. Pépite ne gagne pas de sang-froid cette fois.": "You sold while the portfolio was down 10 % or more: it is the reflex that costs the most in a PEA. Pépite gains no composure this time.",
  "Vous détenez {0} en direct ({1}) et via {2} ({3}) : {4} au total.": "You hold {0} directly ({1}) and through {2} ({3}): {4} in total.",
  "Vous faites mieux que le panel, de {0} points.": "You do better than the panel, by {0} points.",
  "Vous le battez de": "You beat it by",
  "Vous l’avez rachetée depuis.": "You have bought it back since.",
  "Vous n’avez pas vendu dans la baisse : Pépite gagne en sang-froid.": "You did not sell in the fall: Pépite gains composure.",
  "Vous n’avez pas vendu dans la baisse.": "You did not sell in the fall.",
  "Vous pouvez vous connecter avec votre nouveau mot de passe.": "You can log in with your new password.",
  "Vous terminez au niveau de « ne rien faire ».": "You end level with “doing nothing”.",
  "Vous utilisez l’application installée.": "You are using the installed app.",
  "Vue du portefeuille": "Portfolio view",
  "Vue d’ensemble de votre PEA.": "Overview of your PEA.",
  "Vérification de la connexion…": "Checking the connection…",
  "Vérification de l’abonnement…": "Checking the subscription…",
  "Vérification impossible.": "Check failed.",
  "Vérification…": "Checking…",
  "Vérifier le panier": "Check the basket",
  "Vérifier l’ordre": "Check the order",
  "Vérifiez chaque champ : rien n’est envoyé avant votre confirmation.": "Check each field: nothing is sent before your confirmation.",
  "Vérifiez l’ordre pour voir la cotation, les frais estimés et les garde-fous.": "Check the order to see the quote, the estimated fees and the guard rails.",
  "Vérifiez votre boîte mail": "Check your mailbox",
  "Vérifiées avant chaque ordre, quelle que soit son origine. La conformité PEA (éligibilité, pas de crédit ni de vente à découvert) s’applique toujours.": "Checked before each order, whatever its origin. PEA compliance (eligibility, no credit or short selling) always applies.",
  "Watchlist": "Watchlist",
  "Watchlist (": "Watchlist (",
  "Watchlist ({0})": "Watchlist ({0})",
  "Watchlist vide.": "Empty watchlist.",
  "Watchlist · aucun intérêt": "Watchlist · no interest",
  "Watchlist · intérêt faible": "Watchlist · low interest",
  "Watchlist · intérêt fort": "Watchlist · strong interest",
  "Watchlist · intérêt moyen": "Watchlist · medium interest",
  "abonné": "subscribed",
  "abonnés": "subscribed",
  "achat {0} · vente {1}": "buy {0} · sell {1}",
  "actuellement). En attendant, le rapport quotidien actuel continue d’être généré et envoyé par e-mail.": "currently). Meanwhile, the current daily report keeps being generated and emailed.",
  "ancien": "former",
  "annoncé {0} %, observé {1} % ({2})": "stated {0} %, observed {1} % ({2})",
  "apportés.": "contributed.",
  "après {0} ventes à perte": "after {0} losing sales",
  "armé": "armed",
  "armé, cours indisponible": "armed, price unavailable",
  "armée": "armed",
  "armés": "armed",
  "au": "to",
  "au dollar": "to the dollar",
  "au dollar australien": "to the Australian dollar",
  "au dollar canadien": "to the Canadian dollar",
  "au dollar taïwanais": "to the Taiwan dollar",
  "au franc suisse": "to the Swiss franc",
  "au lieu de": "instead of",
  "au total.": "in total.",
  "au won": "to the won",
  "au yen": "to the yen",
  "au yuan et au dollar de Hong Kong": "to the yuan and the Hong Kong dollar",
  "aucune prévision notée": "no forecast scored",
  "autant que pile ou face": "as good as a coin toss",
  "avant les 5 ans, le": "before the 5 years, the",
  "bilan du panel": "panel scorecard",
  "bord : {0} % du seuil": "edge: {0} % from the level",
  "bébé": "baby",
  "cible": "target",
  "clarté": "clarity",
  "concentré": "concentrated",
  "connecté": "connected",
  "cours indisponible": "price unavailable",
  "coûté": "cost",
  "dans": "in",
  "dans {0} jours": "in {0} days",
  "de chances d’atteindre": "chance of reaching",
  "de frais estimés pour les achats, pour qu’une fois achetées, les lignes laissent le compte SIM à la valeur du PEA.": "of estimated fees for the purchases, so that once bought, the lines leave the SIM account at the PEA's value.",
  "de lignes non copiables restent en liquidités.": "of lines that cannot be copied stay in cash.",
  "de liquidités": "in cash",
  "de moins": "less",
  "de plus": "more",
  "de prélèvements sociaux, au lieu de": "of social contributions, instead of",
  "de simulation": "simulation",
  "de son plus haut historique (": "from its all-time high (",
  "de votre compte chaque année": "of your account every year",
  "de {0} titre{1} ·": "of {0} share{1} ·",
  "demandé à Gladys": "asked Gladys",
  "depuis": "since",
  "depuis le début": "since the start",
  "depuis le {0}": "since {0}",
  "des actions mondiales": "of world equities",
  "différé de {0} min": "delayed by {0} min",
  "différée de {0} min": "delayed by {0} min",
  "disponibles pour trader": "available to trade",
  "dont": "including",
  "du CAC 40": "of the CAC 40",
  "du CAC 40, sans vendre": "of the CAC 40, without selling",
  "du CAC 40, sans vendre{0}": "of the CAC 40, without selling{0}",
  "du PEA.": "of the PEA.",
  "du capital parié à la baisse par": "of the capital bet on a fall by",
  "du mois": "of the month",
  "du seuil": "from the level",
  "décision": "decision",
  "décisions justes sur": "right decisions out of",
  "désactivée": "disabled",
  "d’impôts et de prélèvements avec la clôture.": "of taxes and contributions with the closing.",
  "en attente.": "pending.",
  "en cours": "in progress",
  "en cours d’évaluation ·": "being assessed ·",
  "en dépensant.": "by spending.",
  "en toute": "in full",
  "en vote par calibration": "in calibration voting",
  "est connecté et synchronisé.": "is connected and synchronised.",
  "est à jour.": "is up to date.",
  "ex. 10 000": "e.g. 10,000",
  "ex. 98 000": "e.g. 98,000",
  "ex. Faut-il renforcer avant les résultats ?": "e.g. Should I reinforce before the results?",
  "ex. Stratège macro": "e.g. Macro strategist",
  "expert": "expert",
  "experts": "experts",
  "experts actifs (": "active experts (",
  "exposition actions": "equity exposure",
  "face au CAC 40 dans le sens annoncé.": "against the CAC 40 in the stated direction.",
  "face au milieu de fourchette": "against the mid of the spread",
  "faible": "weak",
  "fermer": "close",
  "fois sur": "times out of",
  "fonds (au": "funds (at",
  "forte": "strong",
  "févr.": "Feb.",
  "gardée au journal": "kept in the journal",
  "hors plan": "outside the plan",
  "hypothèse": "hypothesis",
  "idée du panel": "panel idea",
  "inchangé · reste": "unchanged · left",
  "jours": "days",
  "jours.": "days.",
  "juste": "right",
  "justes": "right",
  "laisserait le plan ouvert et coûterait": "would leave the plan open and cost",
  "le": "on",
  "les liens entre vos lignes ne sont pas encore mesurables": "the links between your lines cannot be measured yet",
  "ligne": "line",
  "ligne du pilote · {0}": "pilot's line · {0}",
  "ligne(s) exclue(s) des rapports quotidiens — elles restent comptées dans les totaux.": "line(s) excluded from the daily reports — they still count in the totals.",
  "lignes indépendantes de même taille, et": "independent lines of the same size, and",
  "liquidités": "cash",
  "liquidités insuffisantes": "not enough cash",
  "légende": "legend",
  "majorité": "majority",
  "marquée": "marked",
  "modèles disponibles.": "models available.",
  "médian {0}": "median {0}",
  "naviguer": "navigate",
  "non coupable": "not guilty",
  "notées à": "scored at",
  "nouvelle ligne": "new line",
  "opération": "trade",
  "opérations": "trades",
  "ordre": "order",
  "ouvert": "open",
  "ouvrir": "open",
  "par Saxo, à l’envoi": "by Saxo, when sent",
  "par action ·": "per share ·",
  "par an": "per year",
  "par an en moyenne, volatilité": "per year on average, volatility",
  "par an en réinvestissant, contre": "per year by reinvesting, against",
  "par défaut": "by default",
  "par mois en moyenne": "per month on average",
  "par mois.": "per month.",
  "pas encore": "not yet",
  "pire : {0}": "worst: {0}",
  "plus-value latente": "unrealised gain",
  "point": "point",
  "points": "points",
  "pondération": "weighting",
  "positions": "positions",
  "pour importer votre portefeuille et suivre sa valorisation en temps réel.": "to import your portfolio and track its value in real time.",
  "pour que le fantôme paie ses ordres.": "so that the ghost pays for its orders.",
  "prévision": "forecast",
  "prévision notée": "forecast scored",
  "prévisions notées": "forecasts scored",
  "pts": "pts",
  "pts)": "pts)",
  "quasi nulle": "almost none",
  "rapport": "report",
  "rapport suivi": "report followed",
  "rapports suivis": "reports followed",
  "rapporté": "earned",
  "rejoint le panel.": "joined the panel.",
  "rumeur prête": "rumour ready",
  "rumeurs prêtes": "rumours ready",
  "réel": "real",
  "réelle": "real",
  "réfléchit…": "thinking…",
  "régime de marché": "market regime",
  "sans majorité": "no majority",
  "scénario de résultats": "earnings scenario",
  "soit": "i.e.",
  "suivi": "followed",
  "sur": "out of",
  "sur les versements": "on the deposits",
  "séances, face au": "sessions, against the",
  "trajectoire des taux": "rate path",
  "très diversifié": "very diversified",
  "unanimité": "unanimity",
  "unanimité après débat": "unanimity after debate",
  "utilisés": "used",
  "valeur restante": "security left",
  "valeurs chargées — en cache pour aujourd'hui": "securities loaded — cached for today",
  "valeurs restantes": "securities left",
  "versement": "deposit",
  "versés sur": "deposited out of",
  "via": "via",
  "voix ×": "vote ×",
  "vos lignes bougent beaucoup ensemble": "your lines move a lot together",
  "vos lignes sont modérément liées": "your lines are moderately linked",
  "vos lignes évoluent assez indépendamment": "your lines move fairly independently",
  "votre portefeuille {0} de {1} aujourd’hui": "your portfolio {0} by {1} today",
  "{0} % de décisions justes": "{0} % right decisions",
  "{0} % mieux que pile ou face": "{0} % better than a coin toss",
  "{0} % moins bien que pile ou face": "{0} % worse than a coin toss",
  "{0} (l’âge de votre PEA)": "{0} (your PEA's age)",
  "{0} : générez la synthèse du jour.": "{0}: generate today's summary.",
  "{0} : {1} sur 100": "{0}: {1} out of 100",
  "{0} Sensibilité de chaque ligne à : {1}.": "{0} Sensitivity of each line to: {1}.",
  "{0} a quitté le panel.": "{0} left the panel.",
  "{0} acté(s) d'office": "{0} adopted outright",
  "{0} ajouté à la watchlist": "{0} added to the watchlist",
  "{0} an{1}": "{0} year{1}",
  "{0} appareil": "{0} device",
  "{0} appareils": "{0} devices",
  "{0} avis suivis · poids de vote ×{1}": "{0} opinions followed · vote weight ×{1}",
  "{0} convergence(s)": "{0} convergence(s)",
  "{0} critique, {1} répond": "{0} criticises, {1} answers",
  "{0} de vos placements sont dans des ETF dont seules les principales lignes sont publiées : le reste est réparti sur des centaines d’entreprises.": "{0} of your investments are in ETFs whose main lines only are published: the rest is spread over hundreds of companies.",
  "{0} de {1} {2} — {3}{4}": "{0} of {1} {2} — {3}{4}",
  "{0} de {1} · {2}": "{0} of {1} · {2}",
  "{0} du portefeuille": "{0} of the portfolio",
  "{0} décision{1} suivie{2} sur {3}, {4} débat{5} depuis le {6}.": "{0} decision{1} followed out of {3}, {4} debate{5} since {6}.",
  "{0} désaccord(s) persistant(s)": "{0} persistent disagreement(s)",
  "{0} en arbitrage": "{0} in arbitration",
  "{0} et {1} mois": "{0} and {1} months",
  "{0} exclu des rapports quotidiens": "{0} excluded from the daily reports",
  "{0} exclue(s) des rapports": "{0} excluded from the reports",
  "{0} exécuté{1}, {2} non": "{0} executed, {2} not",
  "{0} futurs en {1} ans": "{0} futures in {1} years",
  "{0} invalide.": "{0} invalid.",
  "{0} jour{1}": "{0} day{1}",
  "{0} le détail de {1}": "{0} the detail of {1}",
  "{0} manquant.": "{0} missing.",
  "{0} modèles disponibles chez {1}.": "{0} models available at {1}.",
  "{0} mois": "{0} months",
  "{0} ordres annulés": "{0} orders cancelled",
  "{0} ordres passés au marché": "{0} orders placed at market",
  "{0} ordre{1}": "{0} order{1}",
  "{0} ordre{1} envoyé{2}": "{0} order{1} sent",
  "{0} pb": "{0} bp",
  "{0} position(s) suivie(s)": "{0} position(s) tracked",
  "{0} prévision{1} en attente : elles sont notées {2} séances après chaque débat.": "{0} forecast{1} pending: they are scored {2} sessions after each debate.",
  "{0} pt": "{0} pt",
  "{0} pts": "{0} pts",
  "{0} retiré de la watchlist": "{0} removed from the watchlist",
  "{0} rumeur": "{0} rumour",
  "{0} rumeur prête": "{0} rumour ready",
  "{0} rumeurs": "{0} rumours",
  "{0} rumeurs prêtes": "{0} rumours ready",
  "{0} réintégré aux rapports quotidiens": "{0} included in the daily reports again",
  "{0} sur {1} notées": "{0} out of {1} scored",
  "{0} sur {1} pour l'instant.": "{0} out of {1} for now.",
  "{0} sur {1}, portefeuille et watchlist.": "{0} out of {1}, portfolio and watchlist.",
  "{0} séance{1} de baisse": "{0} down session{1}",
  "{0} titre{1}": "{0} share{1}",
  "{0} tranche{1} sur {2}, tous les {3} jour{4} de bourse à {5} · total": "{0} slice{1} of {2}, every {3} trading day{4} at {5} · total",
  "{0} valeur": "{0} security",
  "{0} valeur restante": "{0} security left",
  "{0} valeur(s)": "{0} security(ies)",
  "{0} valeurs": "{0} securities",
  "{0} valeurs restantes": "{0} securities left",
  "{0} versement{1}": "{0} deposit{1}",
  "{0} · PEA Wallet": "{0} · PEA Wallet",
  "{0} · le {1}": "{0} · on {1}",
  "{0} · {1} gagnante{2}": "{0} · {1} winning",
  "{0} · {1} ligne{2}": "{0} · {1} line{2}",
  "{0} · {1} ordre{2}": "{0} · {1} order{2}",
  "{0} · {1} ordre{2}{3}": "{0} · {1} order{2}{3}",
  "{0} · {1} position{2} déclarée{3}": "{0} · {1} position{2} declared",
  "{0} · {1} · {2} % du panel": "{0} · {1} · {2} % of the panel",
  "{0} à la majorité": "{0} by majority",
  "{0} étalé{1} · {2}": "{0} staggered · {2}",
  "{0} — poids cible {1}": "{0} — target weight {1}",
  "{0}, au {1}": "{0}, to {1}",
  "{0}, inverse": "{0}, inverse",
  "{0}, rapporteur du panel": "{0}, the panel's rapporteur",
  "{0}, {1} séances.": "{0}, {1} sessions.",
  "{0}Obtenez une clé sur {1}.": "{0}Get a key on {1}.",
  "{0}{1} pt": "{0}{1} pt",
  "· Latente": "· Unrealised",
  "· Retraits": "· Withdrawals",
  "· Saxo {0}": "· Saxo {0}",
  "· au marché": "· at market",
  "· clé": "· key",
  "· compte": "· account",
  "· déjà engagé": "· already committed",
  "· envoi à {0} le {1}": "· sent at {0} on {1}",
  "· limite {0}": "· limit {0}",
  "· pire : {0}": "· worst: {0}",
  "· rapporteur {0}": "· rapporteur {0}",
  "· retenue {0}": "· withholding {0}",
  "· santé": "· health",
  "· sûr de lui : juste": "· when confident: right",
  "· tour {0}": "· round {0}",
  "· ventes :": "· sales:",
  "· voix ×": "· voice ×",
  "· {0} ordre{1} en cours": "· {0} open order{1}",
  "· {0} titres": "· {0} shares",
  "· {0} titre{1} ·": "· {0} share{1} ·",
  "· écrit le": "· written on",
  "À acheter :": "To buy:",
  "À chaque palier, à partir de l’enfance, Pépite prend la branche que montre votre portefeuille à ce moment-là, et la garde : chaque PEA grandit à sa façon.": "At each stage, from childhood on, Pépite takes the branch your portfolio shows at that moment, and keeps it: each PEA grows its own way.",
  "À chaque tour, chaque expert intervient une fois sur les points ouverts ; la table ronde s'arrête dès que tout a convergé. Avec {0} experts : jusqu'à {1} interventions.": "At each round, each expert speaks once on the open points; the round table stops as soon as everything has converged. With {0} experts: up to {1} contributions.",
  "À confirmer": "To confirm",
  "À déclarer telle quelle (Redirect URI) dans votre application Saxo, en SIM comme en réel.": "To declare as is (Redirect URI) in your Saxo application, in SIM as in real money.",
  "À la date du": "As of",
  "À la une : {0}.": "Headline: {0}.",
  "À retenir": "Key points",
  "À venir": "Upcoming",
  "Âge inconnu : renseignez la date d’ouverture de votre PEA.": "Unknown age: enter your PEA's opening date.",
  "Écart": "Gap",
  "Écart avec votre portefeuille réel": "Gap with your real portfolio",
  "Écart du cours limite": "Limit price gap",
  "Écarter": "Dismiss",
  "Écarter cette proposition ?": "Dismiss this proposal?",
  "Écarté": "Dismissed",
  "Échap": "Esc",
  "Échec": "Failure",
  "Échec de l’envoi du message.": "Failed to send the message.",
  "Échec du panel": "Panel failure",
  "Échéance": "Due date",
  "Éclaircie": "Sunny spells",
  "Écoute": "Listening",
  "Écrit en direct": "Written live",
  "Écrit par": "Written by",
  "Édition": "Edition",
  "Édition du matin · N°": "Morning edition · No.",
  "Également en portefeuille": "Also in the portfolio",
  "Égaux": "Equal",
  "Énergie": "Energy",
  "Équilibre sectoriel et géographique du PEA.": "Sector and geographic balance of the PEA.",
  "Établissement qui tient votre PEA.": "Institution that holds your PEA.",
  "État du débat": "Debate state",
  "États": "States",
  "États-Unis": "United States",
  "Évaluation des risques": "Risk assessment",
  "Évaluation des risques et recommandations": "Risk assessment and recommendations",
  "Évolution du portefeuille": "Portfolio evolution",
  "à": "at",
  "à la couronne danoise": "to the Danish krone",
  "à la couronne suédoise": "to the Swedish krona",
  "à la lettre.": "to the letter.",
  "à la livre sterling": "to the pound sterling",
  "à la roupie indienne": "to the Indian rupee",
  "à moins de 2 %": "within 2 %",
  "à partir des recherches du jour.": "from today's research.",
  "à verser": "to deposit",
  "à votre capital actuel :": "to your current capital:",
  "écart inférieur à une action": "gap below one share",
  "écart sous le minimum": "gap below the minimum",
  "écrit en direct": "written live",
  "équilibré": "balanced",
  "Œuf": "Egg",
  "β {0} · reconstituée": "β {0} · reconstructed",
  "— budget": "— budget",
  "— tour {0}": "— round {0}",
  "— {0}, pilote autonome": "— {0}, autonomous pilot",
  "… [contexte tronqué]": "… [context truncated]",
  "€ par an": "€ per year",
  "€/mois": "€/month",
  "→ cours": "→ price",
  "Bande de tolérance": "Tolerance band",
  "Ce que les mêmes ordres auraient coûté avec le barème de la page Frais & fiscalité.": "What the same orders would have cost with the fee schedule of the Fees & tax page.",
  "Chaque débat peut déclencher des ordres : plus de frais et d’allers-retours.": "Every debate may trigger orders: more fees and round trips.",
  "Confiance": "Trusted",
  "Confiance accordée au panel": "Trust given to the panel",
  "Court terme (quelques mois)": "Short term (a few months)",
  "Coût des ventes : après {0} allègement{1} ou vente{2}, la ligne a fait en moyenne {3} pt face au {4} (mieux que lui {5} fois). La plus coûteuse : {6}, décidée le {7} ({8} pt).": "Cost of sales: after {0} trim{1} or sale{2}, the line did {3} pt on average against the {4} (better than it {5} times). The costliest: {6}, decided on {7} ({8} pt).",
  "Donné au panel avant chaque débat : sa décision de liquidités reste dans cette fourchette, et une ligne détenue ne change que pour une raison précise et datée, pas par simple prudence.": "Given to the panel before every debate: its cash decision stays within this range, and a held line only changes for a specific, dated reason, not out of mere caution.",
  "D’où vient l’écart": "Where the gap comes from",
  "Effet de ses achats et ventes face à la copie conservée, ligne par ligne ci-dessous.": "Effect of its buys and sells against keeping the copy, line by line below.",
  "Effet des ordres ligne par ligne": "Effect of the orders, line by line",
  "Frais facturés par Saxo SIM": "Fees charged by Saxo SIM",
  "Frais à votre barème": "Fees at your schedule",
  "Hebdomadaire": "Weekly",
  "Horizon": "Horizon",
  "Le pilote autonome ne se rejoue pas : la simulation applique les règles du mode Propositions (seuil de conviction, bande de tolérance) aux débats passés.": "The autonomous pilot cannot be replayed: the simulation applies the Proposals mode's rules (conviction threshold, tolerance band) to past debates.",
  "Le rééquilibrage a lieu le premier jour de bourse de la semaine ; les autres jours, seules les ventes totales et les renforcements unanimes (et les idées du jour) partent.": "Rebalancing happens on the week's first trading day; on other days only unanimous full sales and reinforcements (and the day's ideas) go out.",
  "Les décisions du débat quotidien, transformées en ordres selon vos règles : seuil de conviction, bande de tolérance, rythme, rotation maximale, heure d’exécution.": "The daily debate's decisions, turned into orders by your rules: conviction threshold, tolerance band, pace, maximum turnover, execution time.",
  "Lignes réelles que la copie n’a pas pu acheter, restées en liquidités dans la SIM : {0} pour votre compte.": "Real lines the copy could not buy, left as cash in the SIM: {0} for your account.",
  "Liquidités maximum": "Maximum cash",
  "Liquidités minimum": "Minimum cash",
  "Long terme (plusieurs années)": "Long term (several years)",
  "Montant échangé par le pilote depuis la copie, en % du compte.": "Amount the pilot traded since the copy, in % of the account.",
  "Moyen terme (1 à 3 ans)": "Medium term (1 to 3 years)",
  "Part du compte que le pilote peut échanger sur 7 jours glissants, réduite tant que le bilan du panel n’a pas fait ses preuves.": "Share of the account the pilot may trade over 7 rolling days, reduced until the panel's record has proven itself.",
  "Période d’essai": "Probation",
  "Quotidien": "Daily",
  "Restreint": "Restricted",
  "Rotation": "Turnover",
  "Rotation maximale": "Maximum turnover",
  "Rotation sur 7 jours": "Turnover over 7 days",
  "Rythme": "Pace",
  "Saisissez les liquidités du mandat en nombres.": "Enter the mandate's cash as numbers.",
  "Sans rien toucher": "Doing nothing",
  "Sans rien toucher (copie conservée)": "Doing nothing (copy kept)",
  "Sans rien toucher, la copie de votre portefeuille ferait {0} ; le pilote fait {1}.": "Doing nothing, the copy of your portfolio would make {0}; the pilot makes {1}.",
  "Tout le compte est concerné, lignes achetées par vous comprises. Le code refuse un ordre hors du compte, de la watchlist et du débat, une vente à découvert, une quantité non entière ou un cours éloigné du marché ; à l’envoi, les garde-fous des réglages trading s’appliquent (éligibilité PEA, liquidités, réserve, montant par ordre et par jour, poids maximal d’une ligne, horaires). La discipline du pilote vaut aussi pour l’agent : seuil de conviction, décision non unanime confirmée par le débat précédent, jamais d’ordre sur « Conserver » ni contre le panel, bande de tolérance, frais au plus 1 % de l’ordre, pas d’aller-retour en 7 jours, rotation maximale.": "The whole account is concerned, lines you bought included. The code refuses an order outside the account, the watchlist and the debate, a short sale, a fractional quantity or a price far from the market; when it leaves, the trading settings' guard rails apply (PEA eligibility, cash, reserve, amount per order and per day, maximum line weight, hours). The pilot's discipline also binds the agent: conviction threshold, a non-unanimous decision confirmed by the previous debate, never an order on \"Hold\" nor against the panel, tolerance band, fees at most 1 % of the order, no round trip within 7 days, maximum turnover.",
  "Une ligne ne bouge que si son poids s’écarte d’au moins ce nombre de points, ou de 20 % de son poids s’il est plus grand.": "A line only moves when its weight is off by at least this many points, or by 20 % of its weight if larger.",
  "Vos réglages rejoués sur les débats passés, avec le moteur du portefeuille fantôme : seules les décisions assez convaincues sont suivies, à partir de votre bande de tolérance, net de votre barème de frais.": "Your settings replayed on past debates with the ghost portfolio's engine: only decisions with enough conviction are followed, from your tolerance band, net of your fee schedule.",
  "Votre mandat": "Your mandate",
  "{0} ordre{1} ; la simulation applique le tarif de Saxo, pas forcément le vôtre.": "{0} order{1}; the simulation applies Saxo's pricing, not necessarily yours.",
  "{0} → {1} titres · {2} ordre{3}": "{0} → {1} shares · {2} order{3}",
  "Liquidités visées : {0} (fourchette {1})": "Target cash: {0} (range {1})",
  "Plan du panel": "The panel's plan",
  "Remises en cause non retenues (elles attendent la revue hebdomadaire)": "Challenges not adopted (they wait for the weekly review)",
  "Revue hebdomadaire du {0}, prochaine au plus tard le {1}. Le plan suit votre portefeuille réel : le pilote le lit sur son propre compte. Il ne bouge une ligne que dans le sens de la décision et jusqu’à sa cible, le jour du rééquilibrage ou quand le plan est révisé ; « Conserver » ne le fait jamais revenir sur ses propres décisions, et ses liquidités au-dessus de la fourchette du plan sont réinvesties.": "Weekly review of {0}, next one by {1} at the latest. The plan follows your real portfolio: the pilot reads it on its own account. It only moves a line in the decision's direction and up to its target, on the rebalancing day or when the plan is revised; “Hold” never makes it undo its own decisions, and its cash above the plan's range is reinvested.",
  "Révisée aujourd’hui :": "Revised today:",
  "{0} : {1} au lieu de {2}, {3}.": "{0}: {1} instead of {2}, {3}.",
  "{0} · cible {1}": "{0} · target {1}",
  "{0} · depuis le {1}": "{0} · since {1}",
  "À revoir si : {0}": "To review if: {0}",
  "Réinvestir la trésorerie": "Reinvest the cash",
  "Débat du pilote": "Pilot's debate",
  "Débat du pilote du {0}": "Pilot's debate of {0}",
  "Le débat de votre portefeuille": "Your portfolio's debate",
  "Le jour du rééquilibrage, le panel débat du portefeuille du pilote et lui fixe son propre plan : il reste pertinent même quand le pilote s’éloigne de votre portefeuille. Un débat de plus par rééquilibrage, payé par les clés des experts.": "On the rebalancing day the panel debates the pilot's portfolio and sets its own plan: it stays relevant even when the pilot drifts away from your portfolio. One more debate per rebalancing, paid by the experts' keys.",
  "Le panel revoit le portefeuille de simulation du pilote.": "The panel reviews the pilot's simulation portfolio.",
  "Le pilote lit seulement les débats de votre portefeuille réel, sur son propre compte : moins coûteux, mais ses lignes à lui ne sont débattues que comme « à garder ou non ».": "The pilot only reads the debates on your real portfolio, on its own account: cheaper, but its own lines are only debated as “keep or not”.",
  "Plan du pilote": "Pilot's plan",
  "Son dernier débat": "Its latest debate",
  "Son propre débat": "Its own debate",
  "Établi par le panel sur le portefeuille du pilote le {0}, revu à chaque jour de rééquilibrage. Le pilote ne bouge une ligne que dans le sens de la décision et jusqu’à sa cible, et ses liquidités au-dessus de la fourchette du plan sont réinvesties.": "Set by the panel on the pilot's portfolio on {0}, reviewed on every rebalancing day. The pilot only moves a line in the decision's direction and up to its target, and its cash above the plan's range is reinvested.",
};

module.exports = en;
